import React, { useContext, useEffect, useMemo, useRef, useState , Fragment} from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Card, Button, Checkbox, Form, Icon, Spin, Modal, Tabs, Popconfirm } from "antd";
import OrderdetailsComponent from "./OrderdetailsComponent";
import { deferFocus } from "../../helpers/focusUtils";
import ServiceLevelHeader from "../../components/orders/ServiceLevelHeader";
import MoveTypeBadge from "../../components/common/MoveTypeBadge";
import { catalog as fetchSlCatalog, forAccount as fetchForAccount, losOptions as fetchSlLosOptions } from "../../api/ServiceLevels";
import { fetchRateSheet } from "../../api/Billing";
import { buildServiceLevelIndex, buildLegLos, labelCodeForServiceLevel, buildOrderTypeConfigIndex, DB_ORDER_TYPE_LEGACY_FALLBACK, resolveLegLosCode, resolveLegLosEntry, withServiceLevelDefaultCodes, withAllStandardLos, parseBillingConfigurations, withAllAccountLos } from "../../helpers/serviceLevelDerivation";
import { fetchAccountBillingConfigs } from "../../api/Account";
import AddressLocationDetails from "../../components/orders/AddressLocationDetails";
import ItemsMeasure from "./ItemsMeasure"
import ItemsMeasureUnits from "../../components/order_item_units/ItemsMeasureUnits"
import Select_v2 from "../../stories/components/Select_v2";
import ArrowLeftIcon from "../../../assets/images/ArrowLeft.svg";
import WarehouseIcon from "../../../assets/images/WarehouseColor.svg";
import { OrderConfigContext } from "../../context/OrderConfigContext";
import CreateOrderButton from "../../components/orders/CreateOrderButton";
import { loadGoogleMaps } from "../../utils/Utils";
import OrderLabelInfo from "./OrderLabelInfo";
import ShipperEmails from "./ShipperEmails";
import { fetchLocations } from "../../api/LocationsApi";
import AppConfig from "../../config/AppConfig";
import { WarehouseContext } from "../../context/WarehouseContext";
import CustomerOrderDetails from "../../components/orders/CustomerOrderDetails";
import { normalizePhoneNumber, renderAlertMessage, checkServiceExistance } from "../../helpers/common";
import { getAccountComponents, getAccountConfigs, getComponentDefs, getLevelOfServices, getLinehaulLevelOfServices } from "../../helpers/api_calls";
import { getValueFromArrayOfObjects } from "../../helpers/array_functions";
import { VehicleTypeApi } from "../../api/VehicleType";
import { UserContext } from "../../context/UserContext";
import { MultiStopSaveOrderCall,fetchOrderReferences, fetchZipcodeCheck, saveOrderCall } from "../../api/OrdersApi";
import CreateOrderSidebar from "./CreateOrderSidebar";
import moment from "moment";
import { getAccessorialsCols } from "../../components/common/columnDefs";
import CreateOrderAccessorial from "./CreateOrderAccessorial";
import { fetchUsers } from "../../api/UsersApi";
import { OrgContext } from "../../context/OrgContext";
import SubOrders from "./SubOrders";
import ErrorComponent from "../../components/common/ErrorComponent";
import I18n from "../../common/I18n";
import MultistopOrder from "./MultistopOrder";
import SectionCard from "./SectionCard";
import { getColorForTitleCreateOrderScreen_v2, getOrderTypeIcon, renderNotification, renderOrderCreationNotification } from "../../components/orders/OrderTypeIcons";
import { isLinehaulLegEditLocked, isLtlOrganization } from "../../helpers/orders";
import { areAppointmentsInOrder, checkIsFilled, getLinehaulRouteValidationError, isLinehaulOrderCode, isMultiDayOrder, validateLtlOnHandTimes } from "../../helpers/order_managemnt";
import Documents from "./Documents";
import { AddStopIcon, ArrowBackIcon, CircledCloseIcon, EditOrderCloseIcon } from "../../common/CustomIcon";
import { getDisabledHours } from "../../helpers/date_functions";
import Copyable from "../../components/common/Copyable";
import ConsigneeDetails from "./ConsigneeDetails";
import PropTypes from "prop-types";
import { set } from "lodash";
import WarehouseAccessorials from "./WarehouseAccessorials";
import { alertMessage, capacityError, isEmpty, randomNumber, sortServicesByNames } from "../../common/Common";
import InfoTooltip from "./InfoTooltip";
import DisableWrapper from "./DisableWrapper";
import { fetchHazmatClasses, fetchUNNumbers } from "../../api/HazmatApi";
import { orderApprovalRulesList } from "../../api/OrderApprovalRulesApi";
import { validateApprovalError } from "../../helpers/approvalHelper";
import { validateCompanyName } from "../../components/orders/helpers";
import LineHaulCreateForm from "./LineHaulCreateForm";
import BulkAttachmentUpload from "./BulkAttachmentUpload";
import CustomsInformation from "./CustomsInformation";

const { confirm } = Modal;

// resolveLegLosCode + LEG_LOS_LOCATION_ROLE_TO_TYPE_OF_LOC moved to
// helpers/serviceLevelDerivation.js (shared with ViewOrderScreen for the OLOS
// per-leg LOS lock).

const CreateOrderScreen = (props) => {
  const [refNumbersData, setRefNumbersData] = useState([]); 
  const [options, setOptions] = useState([]); 
  const [vehicleType, setVehicleType] = useState(null);
  const { form, orderResponse, screenMode = "create" , currentPreplan , 
    setOutofPreplan, setIsModified, currentRoute, callFrom, handleClose, setScreenMode, screenFrom, orgRules} = props;
  const { getFieldDecorator, setFieldsValue,getFieldValue } = form;


  const warehouseFilter = useContext(WarehouseContext);
  const { currentOrg,currentRole } = useContext(UserContext);
  const orgContext = useContext(OrgContext);
  const { orderConfig, getOrderTypeFromLabelCode } = useContext(OrderConfigContext);
  const { accountsExceeded, orgDrivers } = orgContext;
  // Phase 4.3 Mode A: account-first inline service-level flow, gated on org config.
  // Off => today's Mode B, byte-identical. Account UI stays AccountBlockV2 (Figma);
  // this screen adds the inline Service Level block between the account + the legs.
  const modeA = orgContext?.orgSettings?.service_level_flow_enabled === "true";
  // Mode A: the permission side of the per-leg LOS lock. A leg is locked only
  // when BOTH this is true AND that leg actually has a Service Level default LOS
  // (serviceLevelLosCode) — a leg with no SL default falls back to the account
  // default and stays editable for everyone (combined at the render below).
  // Requires the "Update Order Tariff" (OLOS) permission; checkServiceExistance
  // bypasses for admin/super-admin and users with no RBAC grants (app
  // convention). Only applies in Mode A, so Mode B LOS editing is unchanged.
  const losEditLocked = modeA && !checkServiceExistance("OLOS");
  // P3 DB-driven order types: when on, getOrderTypeConfig resolves order-type
  // config (type_of_order + form legs + display text) from the move-type catalog
  // instead of the hardcoded enhancedOrderTypes. Off => byte-identical legacy path.
  // Merged onto service_level_flow_enabled (2026-07-13) — the two flags always
  // flipped together, so this is the same value as `modeA` above.
  const dbOrderTypesEnabled = orgContext?.orgSettings?.service_level_flow_enabled === "true";
  const creditsExceededAccnts = accountsExceeded.map(account => account.account_code);
  const [activeKey, setActiveKey] = useState("1");
  const [msLos, setMsLos] = useState(''); // Los for Multi Stop
  const [orderDetails, setOrderDetails] = useState(orderResponse?.customer_order_details 
    ?
    {
          ...orderResponse.customer_order_details,
          notes: orderResponse.notes,
          label_code: orderResponse.order_label,
    } :
    {
    type_of_order: props.location.orderType || 'D',
    label_code: props.location.label_code || 'D', extra_code: props.location.extraCode || '', suppres_schedule_dates: false, skip_warn_hawb_uniqness: false, wh_storage: false,
    // Phase 4 Mode A: when routed here from ServiceLevelOrderModal, the explicit
    // service_level_id chosen there rides along on route state. Absent for the
    // normal (Mode B) create flow, in which case this key is simply undefined
    // and is dropped from customer_order_params like any other unset field.
    ...(props.location.service_level_id ? { service_level_id: props.location.service_level_id } : {}),
    // Phase 4.1 Mode A: prefill the account chosen in the modal so the account
    // select arrives pre-populated. Absent for Mode B, in which case this key
    // is simply undefined and dropped from customer_order_params as usual.
    ...(props.location.account_id ? { account_id: props.location.account_id } : {})})
  //const [orderDetails, setOrderDetails] = useState({})
  // Phase 4.1 Mode A: lock the account select whenever the account was prefilled
  // from ServiceLevelOrderModal's route state. Absent props.location.account_id
  // (Mode B / normal create, and edit screens), this is false and the account
  // select behaves exactly as before.
  const lockAccount = Boolean(props.location.account_id)
  const [waitTime, setWaitTime] = useState(orderResponse?.customer_order_details?.wait_time || 0);
  const [locations, setLocations] = useState(orderResponse?.locations ? orderResponse?.locations : [])
  // Phase 4.3: per-leg LOS source. Seeded from route state for back-compat
  // (route-state Mode A / edit); the Mode A inline flow sets it on SL selection.
  const [serviceLevelLegLos, setServiceLevelLegLos] = useState(props.location.leg_los || null)
  // Phase 4.3 Mode A: SL->move-type index (from catalog), account-applicable SLs
  // (from for_account), and the in-flight flag for the Service Level block.
  const [serviceLevelIndex, setServiceLevelIndex] = useState({})
  const [applicableServiceLevels, setApplicableServiceLevels] = useState([])
  const [loadingServiceLevels, setLoadingServiceLevels] = useState(false)
  // P3: { order_label: enhancedOrderTypes-shaped entry } built from the catalog.
  // null = not loaded (flag off, or fetch pending) => legacy resolution.
  const [dbOrderTypeIndex, setDbOrderTypeIndex] = useState(null)
  const [orderItems, setOrderItems] = useState([])
  const [vehicleTypes, setVehicleTypes] = useState([])
  const [referencesData, setReferencesData] = useState([])
  const [config, setConfig] = useState({}) 
  const [dtiversData, setDtiversData] = useState([])
  const [isClickedOnSave, setIsClickOnSave] = useState(false)
  // New Items & Measure box reports whether any item has a blocking piece-
  // split/weight mismatch; while true the order Create/Save is disabled and
  // submit aborts (applies to both create and entire edit).
  const [itemsMeasureBlocked, setItemsMeasureBlocked] = useState(false)
  // Detailed per-item reason string from the Items & Measure box; shown in the
  // disabled Create/Save button's tooltip so hovering explains WHICH items block.
  const [itemsMeasureBlockedReason, setItemsMeasureBlockedReason] = useState("")
  const handleItemsMeasureBlockedChange = (blocked, reason) => {
    setItemsMeasureBlocked(blocked)
    setItemsMeasureBlockedReason(reason || "")
  }
  const [selectedWarehouse, setSelectedWarehouse] = useState(null)
  const [currentWhCode, setCurrentWhCode] = useState(null)
  // Bumped to remount the warehouse Select when a warehouse change is cancelled,
  // so it snaps back to the current value (Select_v2 keeps internal state that
  // only re-syncs when its value prop actually changes — which it doesn't on cancel).
  const [warehouseSelectKey, setWarehouseSelectKey] = useState(0)
  const [originCode, setOriginCode] = useState(null)
  const [destinationCode, setDestinationCode] = useState(null)
  const [currentLocType, setCurrentLocType] = useState(null)
  const [currentAccount, setCurrentAccount] = useState(orderResponse?.account || {})
  const [errors, setErrors] = useState([])
  const [orderTypeConfig, setOrderTypeConfig] = useState({})
  const [targetWarehouse, setTargetWarehouse] = useState(null)
  const [conditionForOPnOD, setConditionForOPnOD] = useState(false)
  const isShipper = currentRole === "shipper";
  const [selectedWHAccessorials, setSelectedWHAccessorials] = useState([]);
  const [refUpdated, setRefUpdated] = useState(randomNumber())
  const [accessorialDefs, setAccessorialDefs] = useState({
    orgComponents: [],
    displayComponents: [],
    noParamComponents: [],
    accountAccData: []
  })
  const [hoveredField, setHoveredField] = useState('');
  const [selectedColor, setSelectedColor] = useState(_.get(orderResponse?.customer_order_details, "color_tags[0]", null) || null);
  const detailsRef = useRef(null);
  const itemsRef = useRef(null);
  // Entire-edit: lets handleOrderSave flush the Items & Measure box's item/unit
  // drafts (the box has no Save button there) before the order update.
  const itemsSaveRef = useRef(null);
  const labelInfoRef = useRef(null);
  const managerMailsRef = useRef(null);
  const subOrdersRef = useRef(null);
  const templateRef = useRef(null)
  const locationsRef = useRef([]);
  const isFirstLoad = useRef(true);
  const originalAccessorialsRef = useRef({});
  const multiStopsRef = useRef(null);
  const multistopLocationRef = useRef([])
  const losRef = useRef(null)
  const accessorialRef = useRef([]);
  const consigneeDetailsRef = useRef(null)
  const accInputRef = useRef(null)
  const [samaAsOther, setSamaAsOther] = useState(false);
  const [disableAddressFields, setDisableAddressFields] = useState(false);
  const [disableEditLHOrder, setDisableEditLHOrder] = useState(false);
  const [isLinehaulOrder, setIsLinehaulOrder] = useState(false);
  const [selectedhazmatClass, setSelectedHazmatClasses] = useState(null);
  const [selectedUNNumbers, setSelectedUNNumbers] = useState(null);
  const [hazmatDivision, setHazmatDivision] = useState(null);
  const [isHazardous, setIsHazardous] = useState(false);
  const [approvalModal, setApprovalModal] = useState(false);
  const [isHazmat,setIsHazmat] = useState(false);
  const [isDeclared, setIsDeclared] = useState(false);
  const [approvalRules, setApprovalRules] = useState([]);
  const [restrictionMessage, setRestrictionMessage] = useState([]);
  const [requestApproval, setRequestApproval] = useState(false);
  const [deliveryWarehouseID, setDeliveryWarehouseID] = useState(null);
  const [linehaulPathId, setLinehaulPathId] = useState(null);
  const [pickupAppointmentDate, setPickupAppointmentDate] = useState(null);
  const [linehaulTrackingData, setLinehaulTrackingData] = useState(null);
  const [linehaulIsSpecial, setLinehaulIsSpecial] = useState(Boolean(orderResponse?.is_linehaul_special || orderResponse?.customer_order_details?.is_linehaul_special || orderResponse?.linehaul_special || orderResponse?.customer_order_details?.linehaul_special));

  const [customsData, setCustomsData] = useState(null)
  const [clearanceRequired, setClearanceRequired] = useState(false);
  const [bondedOrderChecked, setBondedOrderChecked] = useState(false);
  const [freightType, setFreightType] = useState("AIR");
  const [slIsImported, setSlIsImported] = useState(false);

  useEffect(() => {
    if(!_.isEmpty(orderTypeConfig) && (orderTypeConfig.code === "LH" || orderTypeConfig.code === "NLH")){
      setDisableAddressFields(true);
    }
  }, [orderTypeConfig]);


 const hanldeCloseApprovalModal = () => {
  setApprovalModal(false);
  setIsHazmat(false);
  setIsDeclared(false);
 }

  const handleValidate = (e) => {
    e?.preventDefault?.();
     e?.stopPropagation?.();
    // Block order creation for a credit-limit-exceeded account (covers an
    // account pre-selected via route/quote that the picker's disable can't guard).
    if (!orderResponse?.id && currentAccount?.code && creditsExceededAccnts.includes(currentAccount.code)) {
      renderNotification("This account has exceeded its credit limit. Order creation is not allowed.", "error");
      return;
    }
    // Phase 4.3 Mode A: a service level must be chosen before an order can be
    // CREATED (legs are hidden until then). On edit (orderResponse.id) the order
    // already exists — don't block save even if it predates the SL flow.
    if (modeA && !orderResponse?.id && !orderDetails.service_level_id) {
      renderNotification("Please select a service level before creating the order.", "error");
      return;
    }
    const linehaulError = getLinehaulRouteValidationError(linehaulTrackingData, {
      isLinehaulOrder: isLinehaulOrderCode(orderTypeConfig?.code),
    });
    if (linehaulError) {
      alertMessage(linehaulError, "warning", 10);
      return;
    }
    const locationData = locationsRef.current.map(ref => ref.current && ref.current()) || [];

        const companyNameCheck = validateCompanyName(locationData);
        if (companyNameCheck.length > 0 && orgContext?.orgSettings?.company_name_mandatory == "true") {
          companyNameCheck.forEach((val) => renderNotification(val, "error"));
          return;
        }    

    const errors = areAppointmentsInOrder(locationData)
    const onHandErrors = validateLtlOnHandTimes(locationData, isLtlOrganization(orgContext?.currentOrg || currentOrg), orderTypeConfig)
    const combinedErrors = [...(errors || []), ...(onHandErrors || [])]
    if(combinedErrors?.length > 0){
      setErrors(combinedErrors)
      combinedErrors.forEach((err) => renderNotification(err, "error"));
      return;
    } else {
      setErrors([])
    }
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if(!errors?.lengh > 0){
          const isValidateMobile = config[I18n.t("configurations.move_to_exception_on_invalid_number")];
          if (isValidateMobile === "true") {
            validateMobileNo();
          } else {
            // validateApprovalOrder();
            handleSave();
          }
        }
      } else{
        renderNotification(`Please fill all required fields`, 'error')
      }
    });
  }

  const handleOptionChange = (newOptionsArray, newVehicleType, colorTag, hazmatClass, hazmatDivision, isHazardous, waitTime, selectedUNNumbers) => {
    const selectedClassObj = hazmatClasses?.find(c => c.class_number === hazmatClass);
    const selectedDivisionObj = selectedClassObj?.sub_classes.find(d => d.division === hazmatDivision);

    setOptions(newOptionsArray);
    setVehicleType(newVehicleType);
    setSelectedColor(colorTag)
    setSelectedHazmatClasses(selectedClassObj);
    setSelectedUNNumbers(selectedUNNumbers);
    setHazmatDivision(selectedDivisionObj);
    setIsHazardous(isHazardous)
    setWaitTime(waitTime)
  };
  const handleRefNumberChange = (newRefNumbersData) => {
    setRefNumbersData(newRefNumbersData);
  };


  const validateMobileNo = () => {
    const locationData = locationsRef?.current ? (locationsRef.current.map(ref => ref.current && ref.current())) || [] : [];
    const consigneeDetails = consigneeDetailsRef?.current ? consigneeDetailsRef.current() : {};
    let warnings = [];
    locationData.map((location, index) => {
      if (location?.phoneError) {
        // renderNotification(`Please enter a valid phone number`, "error");
        warnings.push('Invalid phone number(s) in location details')
      }
    });
    if (consigneeDetails?.phoneError) {
      // renderNotification(`Please enter valid phone number`, 'error')
      warnings.push('Invalid phone number in consignee details')
    }
    if (warnings.length > 0) {
      phoneNoError(warnings)
    } else {
      handleSave()
    }
  }

  const handleSubmit = () => {
    const itemsInfo = itemsRef?.current &&  itemsRef.current() || {};
    const losRef = multiStopsRef?.current && multiStopsRef.current();
    const locationData = locationsRef?.current ? (locationsRef.current.map(ref => ref.current && ref.current())) || [] : [];
    setIsLoading(true)
    // Leg-driven (P3): release applies when the order carries a TRANS (interline
    // transfer) delivery leg — byte-equivalent for legacy OBT/RT (the only legacy
    // types with a TRANS leg) and correct for DB-driven types (LT/PLT/RLT/TRF).
    // Mirrors has_recovery, which already keys on the REC leg below.
    const hasRelease = locationData.some((loc) => loc?.type_of_loc === "DELIVERY" && loc?.label_code === "TRANS");
    const managerInfo = managerMailsRef.current() || []
    const details = (detailsRef?.current ?  detailsRef?.current() : {})
    const extraOptions = _.reduce(options, (acc, item) => {
      acc[item.payloadKey] = item.checked;
      return acc;
  }, {});
    const templateDataForSubmit = templateRef?.current ? templateRef?.current() : {};
    const { customClearancePictures: submitCustomClearancePictures, ...restTemplateDataForSubmit } = templateDataForSubmit;
    const detailsInfo = {
      organization_id: currentOrg?.id || '',
      ...orderDetails,
      ...details,
      label_code: orderTypeConfig?.code || (details?.label_code ? details.label_code : orderDetails?.order_label || ''),
      ...itemsInfo.measurements,
      ...restTemplateDataForSubmit,
      has_recovery: locationData.some(loc => loc?.label_code === 'REC') || false,
      has_release:  hasRelease,
      address_type: _.get(locations, "[0].address_type", "COMMERCIAL") || "COMMERCIAL",
      contact_customer: AppConfig.orderContactCustomer[orderDetails.type_of_order],
      account_manager_emails: managerInfo.map(rec => rec.id),
      ...refNumbersData,
      ...extraOptions,
      vehicle_type: vehicleType,
      wait_time: waitTime,
      extra_code: orderTypeConfig?.extraCode || "",
      is_linehaul_special: Boolean(linehaulIsSpecial),
      customs_data: customsData
    }
    const locationsInfo = locationData
    .filter(loc => loc && Object.keys(loc).length > 0)
    .map((loc, locIndex) => {
      const locPayload = { ...loc };
      const is_recovery = loc?.type_of_loc ==="PICKUP" &&  loc?.label_code === 'REC';
      const is_release =  loc?.type_of_loc ==="DELIVERY" &&
        hasRelease &&  loc?.label_code === "TRANS"

        locPayload.is_recovery = is_recovery;
        locPayload.recovery_status = is_recovery ? "in_transit" : "";
        locPayload.is_release = is_release;
        locPayload.release_status = is_release ? "pending" : "";
      if(loc?.appointment?.appt_date){
          locPayload.appointment = {
            ...locPayload.appointment,
          appt_date: moment(locPayload.appointment.appt_date).format("YYYY-MM-DD 00:00:00"),
          slot: locPayload?.slot ? locPayload.slot : (locPayload?.start_time && locPayload?.end_time ? `${locPayload.start_time}-${locPayload.end_time}` :  "08:00-20:00"),
        }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
        }
        return locPayload;
    })
  const data = {
    locations: locationsInfo,
    customer_order_params: detailsInfo,
    // B-CRITICAL-1: ItemsMeasureUnits (the new Items & Measure screen) now
    // persists its own items directly and returns
    // { items_managed_externally: true } from getDataRef instead of a raw
    // items array — sending that array as item_params here fed the wrong
    // shape into the entire-update service's destroy/recreate path (nil
    // weight_type -> 500; empty -> every item+unit destroyed with no
    // recreate). Legacy callers (itemsInfo.items present) are untouched.
    ...(itemsInfo?.items_managed_externally
      ? { items_managed_externally: true }
      : { item_params: itemsInfo?.items?.length > 0 ? _.compact([...itemsInfo.items]) : [] }),
    // // pickup_location_params: _.find(locationsInfo, {type_of_loc : 'PICKUP'}) || {},
    // // delivery_location_params: _.find(locationsInfo, {type_of_loc : 'DELIVERY'}) || {},
  }
  if (submitCustomClearancePictures) {
  data.pictures = [
  ...(data.pictures || []),
  ...(submitCustomClearancePictures || []),
];  }
  saveOrderCall(data, isNew).then((result) => {
        if (result.success) {
          const currentOrder = result?.orders.customer_order || {}
          renderOrderCreationNotification(
            detailsInfo.extra_code || detailsInfo.label_code,
            currentOrder.customer_order_number || "",
            "success",
            5000,
            detailsInfo.type_of_order,
            currentOrder.delivery_order?.order_number || "",
            screenMode,
          );
          if(currentOrder?.id){
            props.history.push(`/orders/${currentOrder.id}/edit`)
          }
          setIsLoading(false)
        }else{
        if (result.warnings && result.warnings.length > 0) {
          capacityError(result.warnings);
        }
          const itemErrors = result.item_errors ? result.item_errors.map(item => `Item ${item.index}: ${item.errors.join(',')}`) : []
          setErrors([].concat(itemErrors,(result.errors || [])))
          navigateToErrors()
          setIsLoading(false)
      }
       })
  }

  const addStop = () => {

    const locationData = locationsRef?.current
      ? locationsRef.current.map((ref) => (ref.current && ref.current()) || null)
      : [];

    const first = locationData[0];

    if (!first || !first.type_of_loc) {
      // No valid first location yet — either just mounted, or refs not ready
      // Decide what you want here: either allow add, or block with a message
      return;
    }

    if (first.type_of_loc === 'DELIVERY') {
      renderNotification("Please make sure your first location is a pickup stop", "error");
      return;
    }

    const checkIsPickup = locationData[0].type_of_loc === 'PICKUP' && config?.allow_single_stop_multiple_stop == "true" && orderTypeConfig?.code === 'MS' && locationData.length == 1;

    setLocations((prevLocations) => {
      const newLocation = {
        type_of_loc: checkIsPickup ? 'DELIVERY' : 'PICKUP',
        label_code: checkIsPickup ? 'D' : 'R',
        loc_order_sequence: prevLocations.length,
      };
      const updatedLocations = [...prevLocations, newLocation];
        setActiveKey((updatedLocations.length).toString());
      return updatedLocations;
    });
  };


  const handleIfLinehaul = (details = {}) => {
    if (orderDetails.account_id != orderResponse?.customer_order_details?.account_id || orderDetails?.warehouse_code != orderResponse?.customer_order_details?.warehouse_code) {
        confirm({
          title: `The Account or ${I18n.t('general.warehouse')} of the order has been changed.`,
          content: "Do you want to update these changes in the corresponding linehaul?",
          okText: "Yes",
          cancelText: "No",
          onOk: () => {
            details.allow_changes_to_linehaul = true;
            handleOrderSave(details);
          },
          onCancel: () => {
            details.allow_changes_to_linehaul = false;
            handleOrderSave(details);
          },
        })
    } else {
        details.allow_changes_to_linehaul = false;
        handleOrderSave(details);
    }
  }

  const handleSave = (details = {}) => {
    if (screenMode !== "create" && orderResponse.type_of_order === "T" && orderResponse?.customer_order_details?.is_lh_order) {
        handleIfLinehaul(details);
      } else {
        details.allow_changes_to_linehaul = false;
        handleOrderSave(details);
      }
    // if(orderTypeConfig?.type_of_order === "MS"){
    //   handleOrderSave(details);
    // } else {
    //   handleOrderSave(details);
    // }
  }

  const phoneNoError = (warnings) => {
    confirm({
      width: 500,
      title: (
        <Row>
          <Col key={`invalid_err`} className="fontWeight500 smallContent">
            {`Invalid Mobile Number${warnings.length > 1 ? "s" : ""}`}.&nbsp;
            {I18n.t("configurations.move_to_exception_on_invalid_warng_msg", {
              field: warnings.join(", "),
              haveMore: warnings.length === 1 ? "" : "s",
            })}
          </Col>
        </Row>
      ),
      content: <div>{I18n.t("messages.proceed_confirm")}</div>,
      cancelText: "No",
      okText: "Yes",
      onCancel: () => {},
      onOk: () => {handleSave()}
    })
  }

  const handleAddressLinehaul = (details) => {
    confirm({
      title: "Changing the destination will remove the existing sub-order target details.",
      content: "Do you want to update these changes in the corresponding linehaul?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        details.allow_target_details_to_delete = true;
        handleOrderSave(details);
      },
      onCancel: () => {
        setErrors([]);
      },
    })
  }


const zipcodePLHDcheck = () => {
  const locationData = locationsRef.current.map(ref => ref.current && ref.current()) || [];

  if (_.isEmpty(locationData[0]?.customer_zipcode) || _.isEmpty(locationData[locationData.length - 1]?.customer_zipcode)) {
    return;
  }

  const zipCodes = {
    pickup_zip_code: locationData[0]?.customer_zipcode,
    delivery_zip_code: locationData[locationData.length - 1]?.customer_zipcode,
  };

  fetchZipcodeCheck(zipCodes, currentOrg?.id).then((result) => {
    const data = result.data;
    const pickupWarehouseIds = result?.data?.pickup_warehouse_ids || [];

    if (result.success && data?.satisfies_plhd) {
      Modal.confirm({
        title: I18n.t("general.warehouse_mismatch"),
        width: 800,
        content: I18n.t("general.warehouse_mismatch_confirm"),
        okText: "Convert to LineHaul",
        cancelText: "Cancel",
        onOk: () => {
          setOrderDetails(prev => ({
            ...prev,
            type_of_order: "T",
            label_code: "PLHD",
            wh_storage: true
          }));
          getOrderTypeConfig("PLHD", null);

          if (pickupWarehouseIds.length) {
            setOrderDetails(prev => ({ ...prev, warehouse_id: pickupWarehouseIds[0] }));
            setLocations(locations.map(loc => ({...loc, accessorials: []})))
          }

          setErrors([]);
        },
        onCancel: () => {
          setErrors([]);
        },
      });
    }
  });
};

  const handleAccessorialsUpdate = (accessorials) => {
    setSelectedWHAccessorials(accessorials);
  };

 const handleApprovalValidation = (result) => {
  const {
    isHazmat,
    isDeclared,
    messages,
    requiresApproval,
  } = validateApprovalError(result.approval_errors);

  if (isHazmat) setIsHazmat(true);
  if (isDeclared) setIsDeclared(true);

  if (requiresApproval) {
    setApprovalModal(true);
    setRestrictionMessage(messages);
  }
};
  const autoAssignDriverWarningModal = (data, detailsData) => {
    confirm({
      width: 500,
      title: I18n.t("messages.go_ahead_confirm"),
      content: (
        <Row>
          {data.map((item, index) => (
            <Col key={index}>
              <h4>
                &nbsp;&nbsp;{item}
              </h4>
            </Col>
          ))}
        </Row>
      ),
      cancelText: "No",
      okText: "Yes",
      onOk: () => {
        detailsData.auto_assign_driver = true;
        handleOrderSave(detailsData)
      },
      onCancel: () => {
        detailsData.auto_assign_driver = false;
        handleOrderSave(detailsData)
      },
    });
  }

  const handleOrderSave = (deatailsData = {}, skipItemsFlush = false) => {
    const itemsInfo = (itemsRef?.current && itemsRef.current()) || {};
    // Entire-edit: the Items & Measure box holds its item/unit edits as drafts
    // and has no Save button of its own, and getDataRef returns
    // items_managed_externally so the order update below skips items. Flush the
    // box first (persists items + rolls up the order weight), THEN re-run this
    // save for the order-level fields. Guarded by skipItemsFlush so the
    // re-entry doesn't loop. Only relevant when the new screen owns items
    // (items_managed_externally); create sends item_params via getDataRef and
    // never sets a saveRef target that needs this.
    if (!skipItemsFlush && itemsInfo?.items_managed_externally && itemsSaveRef?.current) {
      Promise.resolve(itemsSaveRef.current())
        .then((itemsSaved) => {
          // IM1: handleSaveAll returns false when the items did NOT save (whole-
          // batch failure or a blocked piece-split/weight mismatch). Don't
          // proceed to save the order header in that case — the item error is
          // already surfaced, and saving the order now would look like a full
          // save while the items silently didn't persist. Success / nothing-to-
          // save (true / undefined) still proceeds.
          if (itemsSaved !== false) handleOrderSave(deatailsData, true);
        })
        .catch(() => {
          // Item flush threw — do NOT proceed to the order save.
        });
      return;
    }
    const locationData = locationsRef?.current
      ? locationsRef.current.map((ref) => ref.current && ref.current()) || []
      : [];
    const consigneeDetails = consigneeDetailsRef?.current
      ? consigneeDetailsRef.current()
      : {};
      if (consigneeDetails) {
        consigneeDetails.phone = normalizePhoneNumber(consigneeDetails.phone);
      }  
    if (consigneeDetails?.phoneError) {
      renderNotification(`Please enter valid phone number`, "error");
      return;
    }

    const mandatoryFields = (orgRules?.org_billing_rules?.require_fields_as_mandatory || "")
      .split(",")
      .map((f) => f.trim().toLowerCase())
      .filter((f) => f.length > 0);
    const isHawbRequired = mandatoryFields.includes("hawb");
    const isMawbRequired = mandatoryFields.includes("mawb");
    const isItNumberRequired = currentOrg?.code === "MWE" && mandatoryFields.includes("it_number");
    const isDimsRequired = orgRules?.org_billing_rules?.required_dims == "true" || false;
    const isRequiredItems = orgContext?.orgSettings?.require_items_on_order_creation == "true" || false;
    const itemsArr = itemsInfo?.items || [];
    const isRef1Required = mandatoryFields.includes("reference_1");
    const isRef2Required = mandatoryFields.includes("reference_2");
    const referencesData = {
      ...refNumbersData,
      hawb: (refNumbersData?.hawb || "").trim(),
      mawb: (refNumbersData?.mawb || "").trim(),
      it_number: (refNumbersData?.it_number || "").trim(),
      reference_1: (refNumbersData?.reference_1 || "").trim(),
      reference_2: (refNumbersData?.reference_2 || "").trim(),
    }

    const {
      hawb: hawbVal,
      mawb: mawbVal,
      it_number: itNumberVal,
      reference_1: ref1Val,
      reference_2: ref2Val
    } = referencesData;
    
    if (isRef1Required && !ref1Val) {
      renderNotification( `${refNumbersData?.reference_1_type || "Reference 1"} is required`, "error");
      return;
    }
    if (isRef2Required && !ref2Val) {
      renderNotification(`${refNumbersData?.reference_2_type || "Reference 2"} is required`, "error");
      return;
    }
       if (isHawbRequired && !hawbVal) {
      renderNotification("HAWB is required", "error");
      return;
    }
    if (isMawbRequired && !mawbVal) {
      renderNotification("MAWB is required", "error");
      return;
    }
    if (isItNumberRequired && !itNumberVal) {
      renderNotification("IT Number is required", "error");
      return;
    }

    if (isRequiredItems ) {
      // When the new Items & Measure screen owns the items (edit flow), it does
      // NOT return an `items` array — items are persisted via its own API — but
      // it does hand us `items_count` (live persisted + pending-new count). Use
      // that for the "at least one item" rule; the per-item weight/dims checks
      // below are the legacy grid's responsibility and are enforced inside the
      // new screen itself, so skip them when items are managed externally.
      const managedExternally = !!itemsInfo?.items_managed_externally;
      const effectiveItemCount = managedExternally
        ? (itemsInfo?.items_count ?? 0)
        : itemsArr.length;
      if (effectiveItemCount === 0) {
        renderNotification("Please add at least one item", "error");
        return;
      }
      if (managedExternally) {
        // New screen doesn't hand back an items array; it reports how many live
        // items lack weight so this mandatory-weight rule still applies.
        if ((itemsInfo?.items_missing_weight ?? 0) > 0) {
          renderNotification("Item weight is required", "error");
          return;
        }
      } else {
        for (const [index, item] of itemsArr.entries()) {
          if (isEmpty(item.item_weight, true)) {
            renderNotification(`Item ${index + 1} weight is required`, "error");
            return;
          }
        }
      }
    }

    if (isDimsRequired && itemsArr?.length > 0) {
      for (const [index, item] of itemsArr.entries()) {
        if (isEmpty(item.item_length, true) || isEmpty(item.item_width, true) || isEmpty(item.item_height, true)) {
          renderNotification(`Item ${index + 1} dimensions are required`, "error");
          return;
        }
      }
    }

    if (isHazardous) {
      if (orgRules?.org_billing_rules?.enable_UN_hazmat_fields === "true") {
      if (_.isEmpty(selectedUNNumbers) || selectedUNNumbers?.length === 0) {
        renderNotification("Please select UN Number", "error");
        return;
      }}else {
        if (!selectedhazmatClass || !selectedhazmatClass?.class_name) {
        renderNotification("Please select Hazmat Class", "error");
        return;
      }
      if (!hazmatDivision || !hazmatDivision?.division) {
        renderNotification("Please select Hazmat Division", "error");
        return;
      }
    }
    }

    const linehaulError = getLinehaulRouteValidationError(linehaulTrackingData, {
      isLinehaulOrder: isLinehaulOrderCode(orderTypeConfig?.code),
    });
    if (linehaulError) {
      alertMessage(linehaulError, "warning", 10);
      return;
    }

    setIsLoading(true);
    // const isCrossDockOrder =  loc?.label_code === 'REL';
    // Leg-driven (P3): see the identical conversion in handleSubmit above.
    const hasRelease = locationData.some((loc) => loc?.type_of_loc === "DELIVERY" && loc?.label_code === "TRANS");
    const managerInfo = managerMailsRef.current() || [];
    const details = detailsRef?.current ? detailsRef?.current() : {};
    const extraOptions = _.reduce(
      options,
      (acc, item) => {
        acc[item.payloadKey] = item.checked;
        return acc;
      },
      {}
    );
    const templateData = templateRef?.current ? templateRef?.current() : {};
    const { customClearancePictures, deletedClearanceDocId, deletedClearanceDocIds, ...restTemplateData } = templateData;

    // If user deleted the existing clearance doc, strip it from the locations' documents
    // so it doesn't appear in existing_pic_ids and cause duplicates
    const deleteIds = deletedClearanceDocIds || (deletedClearanceDocId ? [deletedClearanceDocId] : []);
    if (deleteIds.length > 0) {
      locations.forEach((loc) => {
        if (loc?.documents) {
          loc.documents = loc.documents.filter(
            doc => !deleteIds.includes(doc.id) && !deleteIds.includes(doc._id)
          );
        }
      });
    }

    const detailsInfo = {
      organization_id: currentOrg?.id || "",
      ...orderDetails,
      ...details,
      label_code:
        orderTypeConfig?.code ||
        (details?.label_code
          ? details.label_code
          : orderDetails?.order_label || ""),
      ...itemsInfo.measurements,
      ...(labelInfoRef?.current ? labelInfoRef?.current() : {}),
      ...restTemplateData,
      is_hazmat_request_approval : isHazmat,
      is_declared_request_approval : isDeclared,
      has_recovery:
        locationData.some((loc) => loc?.label_code === "REC") || false,
      has_release: hasRelease,
      address_type:
        _.get(locations, "[0].address_type", "COMMERCIAL") || "COMMERCIAL",
      contact_customer:
        AppConfig.orderContactCustomer[orderDetails.type_of_order],
      account_manager_emails: managerInfo.map((rec) => rec.id),
      consignee_details: consigneeDetails,
      ...referencesData,
      ...extraOptions,
      vehicle_type: vehicleType,
      wait_time: waitTime,
      ...deatailsData,
      color_tags: selectedColor ? [selectedColor] : [], 
      ...(orgRules?.org_billing_rules?.enable_UN_hazmat_fields === "true"
        ? {
            un_numbers: isHazardous ? selectedUNNumbers : "",
          }
        : {
            hazmat_class: isHazardous
              ? selectedhazmatClass?.class_name
              : "",
            hazmat_division: isHazardous
              ? hazmatDivision?.description
              : "",
          }),
      is_hazardous: isHazardous,
      un_numbers: isHazardous ? selectedUNNumbers : "",
      extra_code: orderTypeConfig?.extraCode || "",
      lh_routing_path_id: linehaulPathId || "",
      linehaul_tracking: linehaulTrackingData || null,
      linehaul_special: Boolean(linehaulIsSpecial),
      customs_data: customsData,
      freight_arrival_date: customsData?.freight_arrival_date,
      general_order_date: customsData?.general_order_date,
      last_free_day: customsData?.last_free_day,
      customs_cleared_date: customsData?.customs_cleared_date,
    };
    if (detailsInfo.type_of_order === "LH" && detailsInfo.order_label === "LH") {
      detailsInfo.target_warehouse = targetWarehouse;
      const subOrders = subOrdersRef.current() || [];
      detailsInfo.lh_order_ids = subOrders.map((rec) => rec.id);
      detailsInfo.sub_orders = subOrders.map((rec) => ({
        order_id: rec.id,
        target_account: rec.target_account_id,
        target_los: rec.target_los_id,
      }));
      delete detailsInfo.warehouse_code;
      delete detailsInfo.warehouse_name;
      delete detailsInfo.account_name;
      if (detailsInfo?.allow_target_details_to_delete) {
        detailsInfo.sub_orders = subOrders.map((rec) => ({
          order_id: rec.id,
        }));
      }
    }
    let locationsInfo = locationData.map((loc, index) => {
      if (index > 0 && loc?.type_of_loc === "DELIVERY") {
        const isanythingFilled = checkIsFilled(loc, ['address_type']);
        if (!isanythingFilled) {
          return null;
        }
      }
      const locPayload = { ...loc };
      // Per-leg LOS is resolved backend-side from los_code + rate_sheet_id (the
      // picked option's sheet; blank = account scope). los_id is never sent — the
      // same code can exist in two contracts, so the backend owns disambiguation.
      delete locPayload.los_id;
      // Combo SL: a non-combo leg ("Rated via Combo") has no user-selectable
      // tariff — it is billed $0 and the backend forces it to NONE. Send los_code
      // 'NONE' explicitly so the create API doesn't fail on a blank tariff for
      // these legs. Same combo-lock derivation the UI uses (per-leg `combo` flag).
      if (Array.isArray(serviceLevelLegLos) && serviceLevelLegLos.some((l) => l.combo)) {
        const matchedLeg = resolveLegLosEntry(loc, serviceLevelLegLos);
        if (matchedLeg && !matchedLeg.combo) locPayload.los_code = 'NONE';
      }

      locPayload.customer_phone_one = normalizePhoneNumber(loc.customer_phone_one);
      locPayload.customer_phone_two = normalizePhoneNumber(loc.customer_phone_two);
      const is_recovery =
        loc?.type_of_loc === "PICKUP" && loc?.label_code === "REC";
      const is_release =
        loc?.type_of_loc === "DELIVERY" &&
        hasRelease &&
        loc?.label_code === "TRANS";
  
      locPayload.is_recovery = is_recovery;
      locPayload.recovery_status = is_recovery ? "in_transit" : "";
      locPayload.is_release = is_release;
      locPayload.release_status = is_release ? "pending" : "";
      const documents = locations?.[index]?.documents || [];
      locPayload.pictures = documents
        .filter((doc) => _.isEmpty(doc.id))
        .map((doc) => _.omit(doc, ["src", "converted_img"]));
      locPayload.existing_pic_ids = documents
        .filter((doc) => !_.isEmpty(doc.id))
        .map((doc) => doc.id);
    
      //locPayload.release_type = is_release ? "pending" : "";
      if (loc?.appointment?.appt_date) {
        const appointment  = locPayload?.appointment || {}
        locPayload.appointment = {
          ...appointment,
          appt_date: moment(locPayload.appointment.appt_date).format(
            "YYYY-MM-DD 00:00:00"
          ),
          slot: appointment?.slot
            ? appointment.slot
            : appointment.start_time && appointment.end_time
            ? `${appointment.start_time}-${appointment.end_time}`
            : "08:00-20:00",
          suppres_schedule_dates: deatailsData?.suppres_schedule_dates || false,
          has_appointment: appointment?.has_appointment || false,
        };
      } else {
        delete locPayload.appointment;
      }

      if (locPayload.appointments && Array.isArray(locPayload.appointments)) {
        locPayload.appointments = locPayload.appointments.map((appt) => ({
          ...appt,
          has_appointment: loc?.appointment?.has_appointment || false,
          has_expedite: loc?.appointment?.has_expedite || false,
        }));
      }

      if (orgContext?.orgSettings?.individual_stop_los_order_level !== "true") {
        if (orderTypeConfig.code === "MS") {
          locPayload.los_code = msLos;
        }
      }
      return locPayload;
    }); //_.isObject(locationsRef.current()) ? [locationsRef.current()] : locationsRef.current();
    // setOrderDetails(detailsInfo);
    // setLocations(locationsInfo);
    // setOrderItems(itemsInfo.items);
    locationsInfo = _.compact(locationsInfo);

    const updatedItems = itemsInfo?.items?.map((item) => {
      const item_weight = isEmpty(item.item_weight) || isEmpty(item.item_weight_in_kgs) ? 0 : _.toNumber(item.item_weight)
      const item_weight_in_kgs = isEmpty(item.item_weight) || isEmpty(item.item_weight_in_kgs) ? 0 : _.toNumber(item.item_weight_in_kgs)
      
      item.item_weight = item_weight;
      item.item_weight_in_kgs = item_weight_in_kgs;

      return item;
    });
    const data = {
      customer_order_params: detailsInfo,
      // item_params: itemsInfo?.items?.length > 0 ? _.compact([...itemsInfo.items]) : [],
      // B-CRITICAL-1: same guard as handleSubmit above — when
      // ItemsMeasureUnits owns item persistence (items_managed_externally),
      // omit item_params entirely and tell the entire-update service so it
      // skips its item destroy/recreate block instead of reading a blank
      // item_params as "delete every item".
      ...(itemsInfo?.items_managed_externally
        ? { items_managed_externally: true }
        : { item_params: updatedItems?.length > 0 ? _.compact(updatedItems) : [] }),
    };
    if(detailsInfo.type_of_order !== 'MS'){
      const pickupLoc = _.find(locationsInfo, { type_of_loc: "PICKUP" });
      const deliveryLoc = _.find(locationsInfo, { type_of_loc: "DELIVERY" });
      data.pickup_location_params =  pickupLoc ? _.omit(pickupLoc, ["documents"]) : {},
      data.delivery_location_params =  deliveryLoc
        ? _.omit(deliveryLoc, ["documents"])
        : {};
      // ✅ Merge warehouse_id into existing object
      if(["NLH","PLHD"].includes(detailsInfo.label_code)){
          if (deliveryWarehouseID || targetWarehouse) {
            data.delivery_location_params = {
              ...data.delivery_location_params,
              warehouse_id: deliveryWarehouseID || targetWarehouse
            };
          }}
      data.warehouse_accessorials = selectedWHAccessorials || [];
      data.customer_order_params.pickup_special = pickupLoc?.pickup_special || false;
      data.customer_order_params.delivery_special = deliveryLoc?.delivery_special || false;
    } else {
      data.locations = locationsInfo;
      data.customer_order_params.auto_assign_driver = detailsInfo?.auto_assign_driver ?? null;
    }
      if (!detailsInfo.is_template || !detailsInfo.isRecurringOrder) {
        delete data.customer_order_params.template_configs;
    }

    delete data.customer_order_params.isRecurringOrder;
    delete data.customer_order_params.address_type;

if (customClearancePictures?.length > 0 && detailsInfo.type_of_order !== 'MS') {
  const hasPickup = !_.isEmpty(data.pickup_location_params);
  const hasDelivery = !_.isEmpty(data.delivery_location_params);

  if (hasPickup && hasDelivery) {
    data.pickup_location_params = {
      ...data.pickup_location_params,
      pictures: [
        ...(data.pickup_location_params?.pictures || []),
        ...customClearancePictures,
      ],
    };
    data.delivery_location_params = {
      ...data.delivery_location_params,
      pictures: [
        ...(data.delivery_location_params?.pictures || []),
        ...customClearancePictures,
      ],
    };
  } else if (hasPickup) {
    data.pickup_location_params = {
      ...data.pickup_location_params,
      pictures: [
        ...(data.pickup_location_params?.pictures || []),
        ...customClearancePictures,
      ],
    };
  } else if (hasDelivery) {
    data.delivery_location_params = {
      ...data.delivery_location_params,
      pictures: [
        ...(data.delivery_location_params?.pictures || []),
        ...customClearancePictures,
      ],
    };
  }
}

    saveOrderCall(data, isNew).then((result) => {
      if (result.success) {
        let currentOrder;
        setIsModified(true)
        if (!callFrom.includes("orders")) { //['preplan', 'dispatch']
          handleClose("create", I18n.t("messages.order_saved"), true)
        } else {
          if (detailsInfo.type_of_order === "M") {
            currentOrder = result?.orders || {};
            renderOrderCreationNotification(
              detailsInfo.extra_code || detailsInfo.label_code,
              currentOrder.pickup_order?.order_number || "",
              "success",
              5000,
              detailsInfo.type_of_order,
              currentOrder.delivery_order?.order_number || "",
              screenMode
            );
            if (currentOrder?.pickup_order?.pickup_order_id) {
              props.history.push(
                `/orders/${currentOrder.pickup_order.pickup_order_id}/details`
              );
            }
          } else {
            currentOrder = result?.orders?.customer_order || {};
            // renderNotification(`Order ${currentOrder.customer_order_number} has been created`, 'success')
            renderOrderCreationNotification(
              detailsInfo.extra_code || detailsInfo.label_code,
              currentOrder.customer_order_number,
              "success",
              5000,
              "",
              "",
              screenMode
            );
            if (currentOrder?.id) {
                props.history.push(`/orders/${currentOrder.id}/details`);
                if (orderDetails.type_of_order === 'LH' && detailsInfo?.allow_target_details_to_delete && detailsInfo?.sub_orders?.length > 0) {
                  props.getOrderDetails()
                }
            }
          }
        }
        setIsLoading(false);
      } else {
        if (result.warnings && _.isArray(result.warnings) && result.warnings.length > 0) {

          if (result?.auto_assignment_warning) {
            autoAssignDriverWarningModal(result.warnings, deatailsData);
            return;
          } 

          capacityError(result.warnings, handleSave);
        }
        const itemErrors = result.item_errors
          ? result.item_errors.map(
              (item) => `Item ${item.index}: ${item.errors.join(",")}`
            )
          : [];
        const picErrors = result.picErrors
          ? result.picErrors.map(
              (item) => `Pic ${item.index}: ${item.errors.join(",")}`
            )
          : [];
        // if(_.isObject(_.get(result.errors, "[]"))){
  
        // }
        if (orderDetails.type_of_order === 'LH' && Array.isArray(result.errors) && ["target warehouse is mismatch"].includes(result.errors[0])) {
          handleAddressLinehaul(orderDetails);
        }
        // A 422 can carry `errors` as a bare string (location validators return one), so
        // normalise every shape here — the array-only path used to drop those messages and
        // leave the screen looking like the save succeeded.
        let errors = []
        if (typeof result.errors === "string") {
          errors = [result.errors]
        } else if (Array.isArray(result?.errors) && result.errors.length > 0) {
          const objectErrors = _.get(result.errors, "[0].errors") || [];
          errors = objectErrors?.length > 0 ? objectErrors : result.errors
        } else if (_.isPlainObject(result?.errors) && !isEmpty(result.errors)) {
          errors = result.errors.errors || _.flatten(Object.values(result.errors))
        }
        if(result.approval_errors && !isEmpty(result.approval_errors)){
          handleApprovalValidation(result);
        }
        setErrors([].concat(itemErrors, picErrors, errors));
        navigateToErrors();
        setIsLoading(false);
        // setApprovalModal(false);
      }
    });
  };
  

  const navigateToErrors = () => {
    const errBlock = document.querySelector(`.order_errors`);
    if (!isEmpty(errBlock)) {
      // scrollIntoViewIfNeeded
      errBlock.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }
  }

  const [order, setOrder] = useState({});
  const [warehouses, setWarehouses] = useState([])
  const [accounts, setAccounts] = useState([])
  const [levelOfServices, setLevelOfServices] = useState([])
  // Mode A: code -> name for the org Standard rate sheet's LOS, so a Move-Type /
  // SL default code unioned into a non-Standard-linked account's leg options shows
  // its real name ("SMF TRACTOR TRAILER (TT)") instead of "TT (TT)".
  const [standardLosByCode, setStandardLosByCode] = useState({})
  // Full org Standard rate-sheet LOS list (array). Per product, the leg dropdown
  // shows EVERY Standard tariff, not only the SL-mapped defaults.
  const [standardLosList, setStandardLosList] = useState([])
  // Full account rate-sheet LOS list (array). levelOfServices (account_los_short_list)
  // is restricted to the account's single per-order-type designated LOS
  // (OrderTypeLevelOfService.los_codes); this carries the account's WHOLE rate sheet
  // so the leg dropdown's "Account Tariffs" group shows every account tariff,
  // symmetric with standardLosList driving the "Standard Rate Sheet" group.
  const [accountLosList, setAccountLosList] = useState([])
  // Mode A: an Account-Defaults service level can carry per-leg default LOS codes
  // taken from the org Standard rate sheet. For an account whose OWN rate sheet
  // lacks such a code, it won't appear in the account-scoped levelOfServices — so
  // union the service level's own leg default codes in, making them selectable and
  // letting resolveLegLosCode prefill them. The order then submits the code and the
  // backend resolves it account-first with a Standard-sheet fallback. Only the SL's
  // own default codes are added (not the whole Standard catalog).
  const losOptions = useMemo(
    () => withAllStandardLos(withAllAccountLos(levelOfServices, accountLosList), standardLosList),
    [levelOfServices, accountLosList, standardLosList]
  )
  const [linehaulLevelOfServices, setLinehaulLevelOfServices] = useState([])
  const [standardLinehaulLosList, setStandardLinehaulLosList] = useState([])
  const [accountBillingConfig, setAccountBillingConfig] = useState({})
  const linehaulLosOptions = useMemo(
    () => (modeA
      ? withAllStandardLos(linehaulLevelOfServices, standardLinehaulLosList)
      : linehaulLevelOfServices),
    [modeA, linehaulLevelOfServices, standardLinehaulLosList]
  )
  // Lane origin must be the PICKUP location's warehouse — the id the details screen sends
  // to lane-details. orderDetails.warehouse_id is the order's *serving* warehouse, which
  // moves to the current terminal once the order is in transit; asking lane-details from
  // there returns a different, shorter path set that does not contain the saved lane, so
  // the edit screen silently loses it. Falls back to the serving warehouse for create,
  // where no pickup-location warehouse exists yet.
  const linehaulOriginWarehouseId = useMemo(
    () => (
      orderResponse?.locations?.find((loc) => loc.type_of_loc === "PICKUP")?.warehouse_id
      || orderDetails.warehouse_id
    ),
    [orderResponse?.locations, orderDetails.warehouse_id]
  )
  const [isWhLoading, setWhLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isNew, setIsNew] = useState(!orderResponse?.id);
  const [isMultiDay, setIsMultiDay] = useState(null);
  const [isSameDay, setIsSameDay] = useState(null);
  const [hazmatClasses, setHazmatClasses] = useState(null);
  const [UNNumbers, setUNNumbers] = useState(null);

  useEffect(() => {
    getWarehouses()
    getVehicleTypes()
    //getOrderTypeConfig()
    loadGoogleMaps()
    getOrgcomponents()
    // getDrivers()
    getHazmatClasses()
    getUNnumbers()
  }, [])

  const getHazmatClasses = async () => {
    try {
      const result = await fetchHazmatClasses();
      if (result.success) {
        setHazmatClasses(result.hazmat_classes)
      }
    } catch (error) {
      console.error('Error using fetched data:', error);
      setHazmatClasses(null)
    }
  };

    const getUNnumbers = async () => {
    try {
      const result = await fetchUNNumbers({
        organization_id: currentOrg?.id || "",
      });
      if (result.success) {
        setUNNumbers(result.un_numbers)
      }
    } catch (error) {
      console.error('Error using fetched data:', error);
      setUNNumbers(null)
    }
  };

  useEffect(() => {
    if (orderResponse?.id) {
      setOrderDetails({
        ...orderResponse.customer_order_details,
        notes: orderResponse.notes || '',
        suppres_schedule_dates: false,
        skip_warn_hawb_uniqness: false,
        label_code: orderResponse.order_label,
      })
      setClearanceRequired(!!orderResponse?.customer_order_details?.clearance_required)
      setSlIsImported(!!orderResponse?.customer_order_details?.is_imported);
      setBondedOrderChecked(!!orderResponse?.customer_order_details?.is_inbound);
      setFreightType(orderResponse?.customer_order_details?.freight_type || "AIR");
      getOrderTypeConfig(orderResponse.order_label, (orderResponse?.locations|| []))
      setTargetWarehouse(orderResponse.target_warehouse)
      setMsLos(_.get(orderResponse, "locations[0].los_code", ""))
      const linehaulLabels = ["PLH", "NLH", "LHD", "PLHD"];
      const orderLabel = orderResponse?.customer_order_details?.order_label;
      const pickupStatus = orderResponse?.pickup_location_details?.status;

      if (linehaulLabels.includes(orderLabel)) {
        setIsLinehaulOrder(true);
        setDisableEditLHOrder(pickupStatus === "COMPLETED");
      } else {
        setIsLinehaulOrder(false);
        setDisableEditLHOrder(false);
      }
      // setLocations(orderResponse?.locations|| [])
    }
  }, [orderResponse])

  useEffect(() => {
    if (warehouses.length > 0 && isEmpty(orderDetails.warehouse_id)) {
      setDeafultWarehouse()
    }
  }, [warehouses])

  const fetchAccountBillingConfig = async () => {
    if (modeA || !orderDetails.account_id || !currentOrg?.id) {
      setAccountBillingConfig({})
      return
    }
    const requestedAccountId = orderDetails.account_id
    try {
      const result = await fetchAccountBillingConfigs(currentOrg.id, requestedAccountId)
      if (requestedAccountId !== orderDetails.account_id) return
      if (result.success) {
        setAccountBillingConfig(parseBillingConfigurations(result.configurations || []))
      } else {
        setAccountBillingConfig({})
      }
    } catch (error) {
      console.error("Error fetching account billing config:", error)
      setAccountBillingConfig({})
    }
  }

  useEffect(() => {
    if (orderDetails?.account_id) {
      setLinehaulLevelOfServices([])
      setStandardLinehaulLosList([])
      getLos()
      getLinehaulLos()
      getOrderReferences()
      fetchAccountConfig()
      fetchAccountBillingConfig()
      setCurrentAccount(_.find(accounts, {id: orderDetails.account_id}) || null)
    } else {
      setLevelOfServices([])
      setLinehaulLevelOfServices([])
      setStandardLinehaulLosList([])
      setAccountBillingConfig({})
      setCurrentAccount(null)
    }
  }, [orderDetails.account_id, accounts])

  useEffect(() => {
    if (modeA) setAccountBillingConfig({})
  }, [modeA])

  useEffect(() => {
    getLos()
    getLinehaulLos()
  },[orderTypeConfig?.code])

  // Phase 4.1 Mode A: re-seed leg los_code once levelOfServices finishes loading.
  // getOrderTypeConfig's own seed pass runs on [orderDetails.label_code, config];
  // config (fetchAccountConfig) and levelOfServices (getLos) resolve independently,
  // so if config wins the race that seed pass sees levelOfServices === [] and skips
  // every leg (unselectable). This effect closes that gap: when levelOfServices
  // transitions to non-empty and leg_los is present, it applies the effective LOS
  // to any location that does NOT already carry a los_code (idempotent — never
  // clobbers a user's manual change or an already-seeded value, so it can't loop).
  // Entirely no-op for Mode B (props.location.leg_los absent).
  useEffect(() => {
    const legLos = serviceLevelLegLos;
    if (!Array.isArray(legLos) || legLos.length === 0) return;
    if (!losOptions || losOptions.length === 0) return;
    setLocations(prevLocations => {
      let changed = false;
      const next = prevLocations.map(loc => {
        if (!loc || loc.los_code) return loc; // don't clobber an existing / user-set value
        const losCode = resolveLegLosCode(loc, legLos, losOptions);
        if (!losCode) return loc;
        changed = true;
        return { ...loc, los_code: losCode };
      });
      return changed ? next : prevLocations;
    });
  }, [losOptions, serviceLevelLegLos])

  // Phase 4.3 Mode A + P3 DB order types: fetch the move-type catalog once on
  // mount (auth-only). Mode A builds the SL->move-type index (badges + label_code
  // derivation); the P3 flag builds the order_label->orderTypeConfig index that
  // getOrderTypeConfig resolves from. No-op when both flags are off.
  useEffect(() => {
    if (!modeA && !dbOrderTypesEnabled) return
    let cancelled = false
    fetchSlCatalog({ orgId: currentOrg?.id }).then((catRes) => {
      if (cancelled) return
      if (catRes?.success) {
        if (modeA) setServiceLevelIndex(buildServiceLevelIndex(catRes.data))
        if (dbOrderTypesEnabled) setDbOrderTypeIndex(buildOrderTypeConfigIndex(catRes.data))
      }
    })
    return () => { cancelled = true }
  }, [modeA, currentOrg?.id])

  // Mode A: load the org Standard rate sheet's LOS once, keyed by code, so
  // withServiceLevelDefaultCodes can union in a default with its real id + name.
  // The `id` is what makes a same-code Standard default a DISTINCT selectable
  // option next to the account's own LOS of the same code.
  useEffect(() => {
    if (!modeA || !currentOrg?.id) return
    let cancelled = false
    Promise.all([fetchRateSheet(currentOrg.id), fetchSlLosOptions()]).then(([rsRes, losRes]) => {
      if (cancelled) return
      const standard = (rsRes?.rate_sheets || []).find((rs) => rs.is_default)
      if (!standard || !losRes?.success) return
      const map = {}
      const list = []
      ;(losRes.data || []).forEach((o) => {
        if (String(o.rate_sheet_id) === String(standard.id)) {
          const rec = { id: String(o.id), code: o.code, name: o.name, rate_sheet_id: String(standard.id) }
          map[o.code] = { id: rec.id, name: rec.name, rate_sheet_id: rec.rate_sheet_id }
          list.push(rec)
        }
      })
      setStandardLosByCode(map)
      setStandardLosList(list)
    })
    return () => { cancelled = true }
  }, [modeA, currentOrg?.id])

  // Mode A: load the account's FULL rate-sheet LOS whenever the account changes, so
  // the leg dropdown's "Account Tariffs" group offers every account tariff — not
  // only the single per-order-type designated code that account_los_short_list
  // returns (see withAllAccountLos). The single-account los_options endpoint applies
  // the canonical scope (los_scope_query): the account's linked rate sheet, or its
  // account-scoped LOS when unlinked. No-op for Mode B / no account.
  useEffect(() => {
    if (!modeA) { setAccountLosList([]); return }
    if (!orderDetails.account_id) { setAccountLosList([]); return }
    let cancelled = false
    fetchSlLosOptions(null, orderDetails.account_id).then((res) => {
      if (cancelled) return
      setAccountLosList(res?.success ? (res.data || []) : [])
    })
    return () => { cancelled = true }
  }, [modeA, orderDetails.account_id])

  // P3: the catalog index arrives async, after the mount/edit-load resolution
  // attempts. Re-run the resolver once when it lands, in two cases:
  //   1. Still unresolved — a DB-only move type (no enhancedOrderTypes entry).
  //   2. Resolved via the LEGACY config (no short_code — DB configs always carry
  //      it) but the label resolves in the DB index. This is the edit screen:
  //      it resolves e.g. 'R' from enhancedOrderTypes before the catalog fetch
  //      returns, so without this re-run the header badge/alias + leg_name stay
  //      legacy even with service_level_flow_enabled on. The re-resolve swaps in the
  //      same legs (the catalog mirrors legacy label_codes) plus the DB display
  //      fields. A DB-resolved config (short_code present) is never re-run.
  useEffect(() => {
    if (!dbOrderTypeIndex) return
    if (orderTypeConfig?.short_code) return // already DB-resolved
    const label = orderResponse?.id ? orderResponse.order_label : orderDetails.label_code
    if (!label) return
    if (!_.isEmpty(orderTypeConfig) && !resolveDbOrderTypeConfig(label, orderDetails.extra_code)) return
    getOrderTypeConfig(label, orderResponse?.id ? (orderResponse?.locations || []) : null, orderDetails.extra_code)
  }, [dbOrderTypeIndex])

  // Phase 4.3 Mode A: load the account's applicable service levels whenever the
  // account changes. Empty when no account. No-op for Mode B.
  useEffect(() => {
    if (!modeA) return
    if (!orderDetails.account_id) { setApplicableServiceLevels([]); return }
    let cancelled = false
    setLoadingServiceLevels(true)
    // On EDIT, ask the API to retain the order's own SL even if it was
    // deactivated (soft-deleted) or is no longer applicable to the account, so
    // the picker shows it selected (disabled) instead of blank. Undefined on create.
    const savedSlId = orderResponse?.id ? orderResponse?.customer_order_details?.service_level_id : undefined
    fetchForAccount(orderDetails.account_id, savedSlId).then((res) => {
      if (cancelled) return
      // Present the service-level picker alphabetically by name (case-insensitive)
      // so the selection list is predictable regardless of the API's order.
      const sls = res?.success ? (res.data || []) : []
      setApplicableServiceLevels(
        sls.slice().sort((a, b) => String(a?.name || "").localeCompare(String(b?.name || ""), undefined, { sensitivity: "base" }))
      )
      setLoadingServiceLevels(false)
    })
    return () => { cancelled = true }
  }, [modeA, orderDetails.account_id])

  // Mode A: a service level's EFFECTIVE per-leg tariffs are account-specific (the
  // template merged with THAT account's AccountServiceLevel overrides). When the
  // account changes, the applicable list reloads for the new account — re-derive the
  // selected SL's leg tariffs from it so the legs don't keep the previous account's
  // LOS. Skip the first population (initial mount / edit hydration keeps its own
  // serviceLevelLegLos). When the SL isn't applicable to the new account, clear the
  // derived legs so they fall back to the new account's own default instead of a
  // stale value; the SL picker surfaces the selection mismatch.
  const slLegLosSeeded = useRef(false)
  useEffect(() => {
    if (!modeA) return
    if (!slLegLosSeeded.current) { slLegLosSeeded.current = true; return }
    const slId = orderDetails.service_level_id
    if (!slId) return
    const sl = applicableServiceLevels.find((s) => s.service_level_id === slId)
    setServiceLevelLegLos(sl ? buildLegLos(sl) : null)
  }, [applicableServiceLevels])

  useEffect(() => {
    if (orderDetails.account_id && accessorialDefs.orgComponents?.length > 0) {
      getAccountComponentDefs()
    }
  }, [accessorialDefs.orgComponents, orderDetails.account_id])

  useEffect(() => {
    if (orderDetails.warehouse_id) {
      setSelectedWarehouse(_.find(warehouses, { id: orderDetails.warehouse_id}) || null)
      setCurrentWhCode(_.find(warehouses, { id: orderDetails.warehouse_id})?.location_code || null)
      getDrivers()
    } else {
      setSelectedWarehouse(null)
      setCurrentWhCode(null)
      setAccounts([])
    }
  }, [orderDetails.warehouse_id, warehouses])

  useEffect(() => {
    if (orderDetails.suppres_schedule_dates) {
     // handleSave()
    }
  }, [orderDetails.suppres_schedule_dates])

  useEffect(() => {
    if (orderDetails.warehouse_id ) {
     getAccounts()
    }
    // orgSettings dep: auto-selection is deferred until settings load (see
    // getAccounts). warehouseWithAccounts/accounts deps: the warehouse->accounts
    // payload loads async — on a hard reload it can land AFTER warehouse_id and
    // settings settle, and without these deps nothing re-ran getAccounts, so
    // the account picker stayed empty.
  }, [orderDetails.warehouse_id, orgContext?.orgSettings, warehouseFilter.warehouseWithAccounts, warehouseFilter.accounts])

  useEffect(() => {
    if(!isNew && orderResponse?.label_info?.origin_port) {
      setOriginCode(orderResponse.label_info.origin_port);
    }
    if(!isNew && orderResponse?.label_info?.destination_port) {
      setDestinationCode(orderResponse.label_info.destination_port);
    }
  }, [orderResponse])

  // useEffect(() => {
  //   if (isNew && _.isEmpty(orderDetails.account_id) && accounts.length > 0) {
  //    updateOrderDetails
  //   }
  // }, [accounts])

  // Update locationsRef when locations change
  useEffect(() => {

if(orderTypeConfig.code !== 'MS'){
 locationsRef.current = locations.map((_, index) => locationsRef.current[index] || React.createRef());
}

    // if(orderTypeConfig.type_of_order === 'MS'){
    //   locationsRef.current.forEach((ref, index) => {
    //       ref.current= () => ({
    //         ...locations[index]
    //     })
    //   })
    // }
    accessorialRef.current = locations.map(() => React.createRef());
    multistopLocationRef.current = locations.map(() => React.createRef());
  }, [locations]);

  useEffect(() => {
    // if(!orderResponse?.id || orderResponse?.id && orderResponse.order_label !== orderDetails.label_code){
    //   getOrderTypeConfig(orderDetails.label_code)
    // }
    if (!orderResponse?.id) {
      getOrderTypeConfig(orderDetails.label_code, null, orderDetails.extra_code)
    }
  }, [orderDetails.label_code, config])

  const getAccounts = () => {
    const accountsData = warehouseFilter.findMatchingAccounts(orderDetails.warehouse_id);
    
    const findFirstNonExceededAccount = (accounts) => {
      if (!accounts || accounts.length === 0) return null;
      return accounts.find(account => !creditsExceededAccnts.includes(account.code)) || null;
    };
    const accountExistsInData = _.findIndex(accountsData, { id: orderDetails.account_id }) >= 0;

    const disableAutoSelection = orgContext?.orgSettings?.disable_account_auto_selection === "true";
    // Mode A create is account-FIRST: the user always picks the account, so
    // auto-select is off regardless of the org setting. (Restores the gate
    // lost in a merge.)
    const isModeACreate = modeA && isNew;
    // Org settings load async — until they arrive we can't know whether
    // auto-selection is disabled, so don't auto-select yet; the settings dep on
    // the getAccounts effect re-runs this once they land.
    const settingsLoaded = !_.isEmpty(orgContext?.orgSettings);

    // Phase 4.1 Mode A: the account prefilled from ServiceLevelOrderModal must
    // survive even if it doesn't (yet) appear in accountsData for the current
    // warehouse (e.g. warehouse/account lists still loading). Skip auto-select
    // entirely in that case. Absent props.location.account_id (Mode B / normal
    // create), this is a no-op and the original auto-select logic is unchanged.
    const isModeAPrefilledAccount = Boolean(props.location.account_id) && orderDetails.account_id === props.location.account_id;

    // The `accountsData.length > 0` guard on the reset branch is critical on a
    // HARD RELOAD of the edit screen: warehouse_id hydrates from the saved order
    // before WarehouseContext.warehouseWithAccounts finishes loading, so
    // findMatchingAccounts returns [] transiently → accountExistsInData is false
    // → without the guard this branch would wipe the saved account_id to "" (and
    // on edit neither restore branch re-fills it). Only clear once the list has
    // actually loaded and the account genuinely isn't in it (real warehouse
    // mismatch). In-app nav is unaffected (accounts already loaded).
    if (settingsLoaded && !isModeAPrefilledAccount && ((_.isEmpty(orderDetails.account_id) && isNew && accountsData.length > 0) ||
      (!_.isEmpty(orderDetails.account_id) && accountsData.length > 0 && !accountExistsInData))) {
      const firstNonExceededAccount = findFirstNonExceededAccount(accountsData);
      const autoSelectedAccountId = (disableAutoSelection || isModeACreate) ? "" : (firstNonExceededAccount?.id || "");
      updateOrderDetails("account_id", autoSelectedAccountId);
      // Auto-selection ON (Mode B, setting off): the account is picked FOR the user here
      // (not via onSelectAccount), so hand focus straight to the first leg's address
      // search — same landing spot as a manual pick / Mode A's post-service-level focus.
      // Empty id => the user must pick it themselves; the field's autofocus handles that.
      if (autoSelectedAccountId && isNew) {
        deferFocus(() => document.querySelector('input[name="lav2_location_search"], input[name="cdf2_search"]'), 250);
      }
    }
    setAccounts(accountsData.filter(acc => !acc.on_hold))
  }

  const getOrgcomponents = async () => {
    try {
      const result = await getComponentDefs();
      if (result.success) {
        setAccessorialDefs({
          ...result.data,
          accountAccData: [],
          })
      }
    } catch (error) {
      console.error('Error using fetched data:', error);
    }
  }
  const getAccountComponentDefs = async () => {
    try {
      const result = await getAccountComponents (currentOrg.id, orderDetails.account_id, accessorialDefs.orgComponents, accessorialDefs.displayComponents);
      if (result) {
        const newAccountAccessorials = result.data ? [...result.data] : [];

        // On first run, cache the original accessorials with their organization accessorial link
        if (isFirstLoad.current) {
          const orderLocations = orderResponse?.locations || locations || [];
          orderLocations.forEach(loc => {
            const locKey = loc.id || loc.loc_order_sequence;
            originalAccessorialsRef.current[locKey] = [];
            if (Array.isArray(loc.accessorials)) {
              loc.accessorials.forEach(orderAcc => {
                const directMatch = newAccountAccessorials.find(
                  newAcc => newAcc._id === orderAcc.account_accessorial_id || newAcc.id === orderAcc.account_accessorial_id
                );
                originalAccessorialsRef.current[locKey].push({
                  ...orderAcc,
                  organization_accessorial_id: directMatch ? directMatch.organization_accessorial_id : null
                });
              });
            }
          });
          isFirstLoad.current = false;
        }

        setLocations(prevLocations => {
          return prevLocations.map(loc => {
            const locKey = loc.id || loc.loc_order_sequence;
            const originalAccs = originalAccessorialsRef.current[locKey] || [];
            const filteredAccs = originalAccs.reduce((acc, orderAcc) => {
              if (orderAcc.organization_accessorial_id) {
                const orgMatch = newAccountAccessorials.find(
                  newAcc => newAcc.organization_accessorial_id === orderAcc.organization_accessorial_id
                );
                if (orgMatch) {
                  acc.push({
                    ...orderAcc,
                    account_accessorial_id: orgMatch._id || orgMatch.id
                  });
                }
              } else {
                const directMatch = newAccountAccessorials.find(
                  newAcc => newAcc._id === orderAcc.account_accessorial_id || newAcc.id === orderAcc.account_accessorial_id
                );
                if (directMatch) {
                  acc.push(orderAcc);
                }
              }
              return acc;
            }, []);
            return {
              ...loc,
              accessorials: filteredAccs
            };
          });
        });

        setAccessorialDefs(
          {
          ...accessorialDefs,
          accountAccData: newAccountAccessorials,
          })
      }
    } catch (error) {
      console.error('Error using fetched data:', error);
    }
  }
  const getOrderReferences = () => {
    fetchOrderReferences(currentOrg.id, orderDetails.account_id).then(
      (result) => {
        if (result.success) {
          setReferencesData(result.references || [])
        } else {
          renderAlertMessage(result.errors)
          setReferencesData([])
        }
      }
    );
  };

  const getLos = async () => {
    const accountIndex = _.findIndex(accounts, {
      id: orderDetails.account_id
    });

    if (accountIndex >= 0) {
      const account = accounts[accountIndex];
      let accountCode = account.code
      if (!isEmpty(account.primary_account_id)) {
        accountCode = getValueFromArrayOfObjects(
          accounts,
          "id",
          account.primary_account_id,
          "code"
        );
      }
      try {
        const result = await getLevelOfServices(accountCode, orderDetails.type_of_order, orderDetails.label_code);
        if (result.success) {
          if(msLos && result.data && _.findIndex(result.data, {code: msLos}) < 0){
            setMsLos("");
            form.setFieldsValue({
              ms_los_code: ''
            })
          }
          setLevelOfServices(sortServicesByNames(result.data, "name"))
        }
        // Use the fetched data here
      } catch (error) {
        console.error('Error using fetched data:', error);
      }
    }
  }

  const getLinehaulLos = async () => {
    const requestedAccountId = orderDetails.account_id;
    const accountIndex = _.findIndex(accounts, { id: requestedAccountId });
    if (accountIndex < 0) return;

    const account = accounts[accountIndex];
    let accountCode = account.code;
    if (!isEmpty(account.primary_account_id)) {
      accountCode = getValueFromArrayOfObjects(
        accounts,
        "id",
        account.primary_account_id,
        "code"
      );
    }

    try {
      const result = await getLinehaulLevelOfServices(
        accountCode,
        orderDetails.label_code,
        currentOrg?.id,
        requestedAccountId
      );
      if (requestedAccountId !== orderDetails.account_id) return;
      if (result.success) {
        setLinehaulLevelOfServices(sortServicesByNames(result.data, "name"));
        setStandardLinehaulLosList(result.standardLinehaulLos || []);
      } else {
        setLinehaulLevelOfServices([]);
        setStandardLinehaulLosList([]);
      }
    } catch (error) {
      console.error("Error fetching linehaul tariffs:", error);
    }
  }

  const fetchAccountConfig = async() => {
    try {
        const result = await getAccountConfigs(orderDetails.account_id, currentOrg.id);
      if (result.success) {
          setConfig(result.data)
      }
      // Use the fetched data here
    } catch (error) {
        console.error('Error using fetched data:', error);
    }
    }

  const getVehicleTypes = () => {
    VehicleTypeApi.fetch().then((result) => {
      if (result.success) {
        setVehicleTypes(result.vehicle_types || [])
      } else {
        renderAlertMessage(result.errors)
        setVehicleTypes(result.vehicle_types || [])
      }
    });
  };

  const setDeafultWarehouse = () => {
    if (isNew === true) {
      const { getWHDetails } = warehouseFilter;
      const currentWh = getWHDetails();
      updateOrderDetails("warehouse_id", (currentWh?.id || ''));
    }
  };
  const getWarehouses = () => {
    setWhLoading(true)
    fetchLocations(AppConfig.warehouseCode, 1, null).then((result) => {
        if (result.success) {
        setWarehouses(result.locations.locations || [])
        } else {
        renderAlertMessage(result.errors)
        }
    }).catch((err) => {
      renderAlertMessage(err)
      })
      .finally(() => {
        setWhLoading(false)
      });;
  };

  const getDrivers = () => {
     const updatedDrivers = orgDrivers.filter(driver => !driver.deleted_at && driver?.warehouse_ids &&
      driver?.warehouse_ids?.includes(orderDetails.warehouse_id));
     setDtiversData(updatedDrivers || [])
   
    // const result = await fetchUsers("driver", 1, null);
    // if (result.success) {
    //   setDtiversData(result.users || [])
    // } else {
    //   setDtiversData([])
    // }
  };

  const updateOrderDetails = (element, value) => {
    setOrderDetails({
      ...orderDetails,
      ...(detailsRef?.current ?  detailsRef?.current() : {}),
      [element]: value
    });
  }

  // Linehaul move types auto-fill the pickup (and origin) legs from the selected
  // warehouse and lock them from manual edits. Changing the warehouse therefore
  // silently rewrites those legs, so warn before applying the change; on confirm
  // the warehouse update cascades into the dependent legs (they re-fill from the
  // new warehouse). On cancel the controlled dropdown keeps the current value.
  const LINEHAUL_WH_CODES = ["LH", "NLH", "LHD"];

  const handleWarehouseChange = (val) => {
    const isLinehaul = LINEHAUL_WH_CODES.includes(orderTypeConfig?.code);
    const currentWhId = orderDetails.warehouse_id;
    if (isLinehaul && currentWhId && val && currentWhId !== val) {
      confirm({
        title: `Changing the ${I18n.t('general.warehouse')} will update the auto-filled pickup leg details.`,
        content: "The pickup and its dependent legs will be updated with the new warehouse's details. Do you want to continue?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => updateOrderDetails("warehouse_id", val),
        // Remount the Select so it discards its optimistic internal value and
        // snaps back to the current warehouse.
        onCancel: () => setWarehouseSelectKey((k) => k + 1),
      });
      return;
    }
    updateOrderDetails("warehouse_id", val);
  };

  const checkConditionForORnOd = (locationData) => {
    const conditionForOPnOD = ['OR', 'OD'].includes(orderTypeConfig.code) && locationData.filter(o => o?.l_type === 'PWL').length > 0;
    setConditionForOPnOD(conditionForOPnOD);
  }


  const handleUpdateWhStorage = () => {
    const locationData = locationsRef.current.map(ref => ref.current && ref.current()) || [];
    const isMultiDay = isMultiDayOrder(locationData)
  }

  const updateLocData = () => {
    const locationData = locationsRef.current.map(ref => ref.current && ref.current()) || [];
    const isMultiDay = isMultiDayOrder(locationData);
    setIsMultiDay(isMultiDay);
    checkConditionForORnOd(locationData)
    const pickupLoc = locationData.find((loc) => loc?.type_of_loc === "PICKUP");
    const appointment = pickupLoc?.appointment;
    const hasExplicitApptDate = Boolean(
      appointment && Object.prototype.hasOwnProperty.call(appointment, "appt_date")
    );
    const pickupDate = hasExplicitApptDate
      ? (appointment.appt_date || null)
      : (appointment?.appt_date || pickupLoc?.appointments?.[0]?.appt_date || null);
    const pickupDateKey = pickupDate ? moment(pickupDate).format("YYYY-MM-DD") : null;
    setPickupAppointmentDate((prev) => (prev === pickupDateKey ? prev : pickupDateKey));
  }

  const handleLocUpdate = (index, loc) => {
    const newLocations = _.cloneDeep(locations)
    newLocations[index] = loc;
    setLocations(newLocations)

    // Update originalAccessorialsRef cache
    const locKey = loc.id || loc.loc_order_sequence;
    const currentAccDefs = accessorialDefs?.accountAccData || [];
    const currentAccDefIds = currentAccDefs.map(d => d._id || d.id);
    const currentOrgAccIds = currentAccDefs.map(d => d.organization_accessorial_id).filter(Boolean);

    const cachedAccs = originalAccessorialsRef.current[locKey] || [];
    
    // Keep cached accessorials that do NOT belong to the current account
    const otherAccountCached = cachedAccs.filter(cachedAcc => {
      const isCurrentAccount = currentAccDefIds.includes(cachedAcc.account_accessorial_id) ||
        (cachedAcc.organization_accessorial_id && currentOrgAccIds.includes(cachedAcc.organization_accessorial_id));
      return !isCurrentAccount;
    });

    // Decorate the new selections with organization_accessorial_id if they match
    const decoratedNewAccs = (loc.accessorials || []).map(orderAcc => {
      const match = currentAccDefs.find(
        d => d._id === orderAcc.account_accessorial_id || d.id === orderAcc.account_accessorial_id
      );
      return {
        ...orderAcc,
        organization_accessorial_id: match ? match.organization_accessorial_id : orderAcc.organization_accessorial_id
      };
    });

    originalAccessorialsRef.current[locKey] = [
      ...otherAccountCached,
      ...decoratedNewAccs
    ];
  }

  const handleLocElementUpdate = (index, element, value) => {
    setLocations((prevLocations) => {
      const newLocations = [...prevLocations];
      const locRefData =
        locationsRef.current[index]?.current?.() || newLocations[index] || {};
      newLocations[index] = { ...locRefData, [element]: value };
      return newLocations;
    });
  };


  const handleRemoveDocuments = (index, ackIds = []) => {
    const idsToRemove = ackIds || [];
    const modifiedAckIds = idsToRemove.map(id => id.replace("_n", "_p"));
    const allIdsToRemove = [...idsToRemove, ...modifiedAckIds];
    // const newLocations = _.cloneDeep(locations);
    // newLocations[index].documents = newLocations[index].documents.filter(
    //   doc => !allIdsToRemove.includes(doc.ack_id)
    // );
    // setLocations(newLocations);

    // remove docs logic
    setLocations((prevLocations) => {
      const updatedLocations = [...prevLocations];
      updatedLocations[index] = {
        ...prevLocations[index],
        // locations can exist without a documents key yet (e.g. only staged
        // OTHER ATTACHMENT uploads) - fall back to an empty list
        documents: (prevLocations[index]?.documents || []).filter(
          doc => !allIdsToRemove.includes(doc.ack_id)
        )
      };
      return updatedLocations;
    });
  };

  // P3: resolve the order-type config from the DB catalog index. null (=> legacy
  // enhancedOrderTypes fallback) when: flag off / index not yet loaded, an
  // extraCode is present (legacy variants like APAD on existing orders), or the
  // label is on the documented legacy-parity fallback list (CDK/WO).
  const resolveDbOrderTypeConfig = (labelCode, extraCode) => {
    if (!dbOrderTypesEnabled || !dbOrderTypeIndex) return null;
    if (extraCode) return null;
    if (DB_ORDER_TYPE_LEGACY_FALLBACK.includes(labelCode)) return null;
    return dbOrderTypeIndex[labelCode] ? _.cloneDeep(dbOrderTypeIndex[labelCode]) : null;
  };

  const getOrderTypeConfig = (labelCode, locations = null, extraCode, legLosOverride) => {
    let typeObject = resolveDbOrderTypeConfig(labelCode, extraCode) || _.cloneDeep(
      extraCode
        ? _.find(orderConfig?.enhancedOrderTypes, { code: labelCode, extraCode })
        : _.find(orderConfig?.enhancedOrderTypes, { code: labelCode })
    );
    if (!typeObject) {
      // Unknown label everywhere (e.g. a DB-only move type before the catalog
      // loads, or a stale legacy code). Leave current config untouched — the
      // catalog effect re-runs this resolver once the index arrives.
      console.error(`getOrderTypeConfig: unresolved order type "${labelCode}"${extraCode ? ` (${extraCode})` : ""}`);
      return;
    }

    if (config.allow_single_stop_multiple_stop == "true" && typeObject.type_of_order === 'MS') {
      const filteredLocations = typeObject.locations?.filter(loc => {
        return loc.label_code !== 'D'
      })
      typeObject.locations = filteredLocations
    }

    setOrderTypeConfig(typeObject)
    const existingLocatios = locations ? [...locations] :_.cloneDeep(locationsRef.current.map(ref => ref.current && ref.current()) || [])
    const newLocations = typeObject?.locations || []
    const updatedLocations =  typeObject?.type_of_order !== 'MS' || actionType === "create" ? newLocations?.map(loc => {
      const  foundLocation = _.find(existingLocatios, { type_of_loc: loc.type_of_loc })
      if(!foundLocation && ['R', 'D'].includes(labelCode)){
        const exchangedLoc = _.find(existingLocatios, { type_of_loc: loc.type_of_loc === 'PICKUP' ? 'DELIVERY': 'PICKUP' })
        return ({
          ...(exchangedLoc ? (
            {
              ...exchangedLoc,
              type_of_loc: loc.type_of_loc === 'PICKUP' ? 'DELIVERY': 'PICKUP',
              label_code: labelCode ? "R" : "D",
              location_label: labelCode ? "R" : "D",
            }
          ) : {}),
          ...loc,
          // Always take the TEMPLATE's leg_name (undefined for legacy configs) so a
          // stale DB leg_name can't leak across an order-type switch onto a
          // legacy-resolved template (e.g. DB PD -> fallback CDK).
          leg_name: loc.leg_name,
        })
      }
      return ({
        ...foundLocation,
        ...loc,
        leg_name: loc.leg_name,
      })
    }): existingLocatios;
    // Phase 4.1 Mode A: seed each leg's los_code from the service-level picker's
    // leg_los onto the matching freshly-templated location, so AddressLocationDetails
    // mounts with the effective LOS already applied (honored as an "incoming" los_code
    // by its own default-LOS effect). Absent props.location.leg_los (Mode B / normal
    // create, and edit screens), seededLocations === updatedLocations and the rest of
    // this function is unchanged.
    const legLos = legLosOverride !== undefined ? legLosOverride : serviceLevelLegLos;
    // Union THIS legLos's default codes (may be a freshly-selected SL not yet in the
    // losOptions memo's serviceLevelLegLos state) so Standard-sourced defaults prefill.
    const seedLosOptions = withServiceLevelDefaultCodes(levelOfServices, legLos, standardLosByCode);
    // Only an explicit SL change (legLosOverride passed by handleModeAServiceLevelChange)
    // may overwrite a leg's existing los_code. On edit re-runs that fall back to the
    // saved SL (serviceLevelLegLos, no override) a leg already carries its SAVED
    // los_code — never clobber it with the SL default, or the user's saved choice is
    // lost on reopen.
    const usingExplicitOverride = legLosOverride !== undefined;
    const seededLocations = Array.isArray(legLos) && legLos.length > 0
      ? updatedLocations.map(loc => {
        if (!usingExplicitOverride && loc.los_code) return loc;
        const losCode = resolveLegLosCode(loc, legLos, seedLosOptions);
        return losCode ? { ...loc, los_code: losCode } : loc;
      })
      : updatedLocations;
    setLocations(seededLocations)
    checkConditionForORnOd(seededLocations)
  }

  const handleTypeChange = (orderType, code, extraCode) => {
    const updatedDetails = {
      ...orderDetails,
      type_of_order: orderType,
      label_code: code,
      extra_code: extraCode || '',
    }
    if (
      ["T"].includes(orderDetails.type_of_order) &&
      ["R", "D"].includes(orderType)
    ) {
      updatedDetails.wh_storage = false
    }
    setOrderDetails(updatedDetails)
    getOrderTypeConfig(code, null, extraCode)
  }
  const getDisabledCodes = () => {
    if(orderResponse?.type_of_order){
      if(orderResponse?.status === 'COMPLETED' || ['MS', 'LH'].includes(orderResponse.type_of_order)) {
        return ['ALL']
      }
      const singleLocationOrders = ['R', 'D', 'TR', 'TD'];
      const isTransfer = orderResponse.type_of_order === 'T'
      if(isTransfer){
        const nonCompletedLocations = orderResponse.locations.filter(loc => ["PENDING",'in_hand','in_transit'].includes(loc.status))
        if(nonCompletedLocations?.length > 0){
          const isPickupCompleted = _.get(_.find(orderResponse.locations, {type_of_loc: 'PICKUP'}),"status", "" ) === "COMPLETED";
          if(isPickupCompleted){
            const currentCode = orderResponse.order_label;
            if(['T', 'RD','RT','OBT', 'B', 'E', 'H'].includes(currentCode)){
              return ['CDK','PCDK','CDKD', 'WO', 'TR', 'TD', 'D','MS', 'LH','NLH','PLH', 'LHD', 'PLHD']
            }else if(['CDK','PCDK','CDKD', 'WO'].includes(currentCode)){
              return ['T', 'RD','RT','OBT', 'TR', 'TD', 'D','MS', 'LH','NLH','PLH', 'LHD', 'PLHD', 'B', 'E', 'H']
            }
          }
        }
      }
      if(orderResponse?.status !== 'COMPLETED'){
        const isNotLinehaul = !['PLH', 'LHD', 'PLHD','NLH'].includes(orderResponse.label_code);
        const isDeliveryOrder = ['D','SDD','MDD','CDK', 'WO'].includes(orderResponse.label_code);
        const isLocationAssigned = _.get(_.find(orderResponse.locations, {type_of_loc: isDeliveryOrder ? 'DELIVERY' : 'PICKUP'}),"status", "" ) !== "PENDING";
        if(isLocationAssigned && isNotLinehaul){
          return ['PLH', 'LHD', 'PLHD','NLH']
        }
      }
    }
    return [];
  }

  const renderSidebar = () => {
    return (
      <CreateOrderSidebar
        getDataRef={templateRef}
        handleSave={handleValidate}
        updateOrderDetails={updateOrderDetails}
        orderDetails={orderDetails}
        isLoading={isLoading}
        handleSubmit={handleValidate}
        actionTpe={actionType}
        onOptionChange={handleOptionChange}
        onRefNumberChange={handleRefNumberChange}
        vehicleTypes={vehicleTypes}
        hazmatClasses={hazmatClasses}
        UNNumber={UNNumbers}
        referencesData={referencesData}
        details={orderDetails}
        setFieldsValue={setFieldsValue}
        updatedAccountId={orderDetails.account_id}
        order_label_code={orderDetails.label_code || orderDetails.order_label}
        screenMode={screenMode}
        conditionForOPnOD={conditionForOPnOD}
        isMultiDay={isMultiDay}
        orgRules={orgRules}
        approvalModal={approvalModal}
        hanldeCloseApprovalModal={hanldeCloseApprovalModal}
        restrictionMessage={restrictionMessage}
        setRequestApproval={setRequestApproval}
        locations={locations}
        clearanceRequired={clearanceRequired}
        setClearanceRequired={setClearanceRequired}
        bondedOrderChecked={bondedOrderChecked}
        setBondedOrderChecked={setBondedOrderChecked}
        freightType={freightType}
        setFreightType={setFreightType}
        serviceLevelIsImported={slIsImported}
        delivery_location_details={orderResponse?.delivery_location_details}
        saveDisabled={itemsMeasureBlocked}
        saveDisabledReason={itemsMeasureBlockedReason || "Fix the errors in Items & Measure before saving the order."}
      />
    );
  };

  const copyOtherLocation = (source, destination) => {
    if (!locationsRef.current[source] || !locationsRef.current[destination]) return; // Ensure both refs exist

    const firstLocation = locationsRef.current[source]?.current();
    const secondLocationRef = locationsRef.current[destination];

    if (firstLocation && secondLocationRef?.current) {
    const updatedData = {
      ...secondLocationRef.current(), // Preserve other fields
      company_name: firstLocation.company_name,
      customer_email: firstLocation.customer_email || "",
      customer_phone_one: firstLocation.customer_phone_one || "",
      customer_phone_two: firstLocation.customer_phone_two || "",
    };
    secondLocationRef.current = () => updatedData;
    setRefUpdated(randomNumber())
    }
  }

  const multiStopItems = () => {
    return (
      <Row type="flex" gutter={8} align="middle" style={{ marginTop: '30px'}}>
        <Col
          style={{ lineHeight: "30px" }}
          onMouseEnter={() => setHoveredField("level Of service")}
          onMouseLeave={() => setHoveredField(null)}
        >
          <div
            className="RefNumbersStyle"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "right",
              justifyContent: "space-between",
            }}
          >
            <span className="heading-3-large require-star-right">
              {I18n.t('general.level_of_service')}
            </span>
            <div style={{ minWidth: 12, marginLeft: 10 }}>
              <InfoTooltip
                label={I18n.t('general.level_of_service')}
                message={[
                  `${I18n.t('general.level_of_service')} defines the type of service provided to an account and is tied to a configured rate. Selecting a ${I18n.t('general.level_of_service')} establishes both the applicable rate and the expectations for the service being delivered.`,
                ]}
              />
            </div>
          </div>
        </Col>
        <Col>:</Col>
        <Col className="table-col-address">
          <Form.Item
            className={"required-star-right custom-form-item"}
            name="ms_los_code"
            key={`ms_los_code`}
          >
            {getFieldDecorator(`ms_los_code`, {
              rules: [
                {
                  required: true,
                  message: `Please select ${I18n.t('general.level_of_service_small')}`,
                },
              ],
              initialValue: msLos,
            })(
              <Select_v2
                data-testid="ms-los-dropdown"
                labelField="name"
                valueField="code"
                codeField="code"
                onChange={(value) => {
                  setMsLos(value);
                  form.setFieldsValue({
                    ms_los_code: value,
                  });
                }}
                options={levelOfServices}
                placeholder="--Select--"
                showSelectOption={true}
                value={msLos}
                style={{ width: 250 }}
                filterOption={(input, option) => {
                  const matchingOption = levelOfServices.find((opt) => opt.code === option.props.value);
                  if (!matchingOption) return false;
                  const nameStr = matchingOption.name || "";
                  const codeStr = matchingOption.code || "";
                  return nameStr.toLowerCase().includes(input.toLowerCase()) ||
                         codeStr.toLowerCase().includes(input.toLowerCase());
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col></Col>
      </Row>
    ); 
  };
  
    

  useEffect(() => {
      if(samaAsOther){
        copyOtherLocation(0, 1)
      }
    }, [samaAsOther])
  const showActionsFunc = (isShipper, currentOrder) => {
    return !(
      isShipper || currentOrder?.customer_order_details?.is_locked === "true" || currentOrder?.is_deleted_order
    );
  };
  const showSidebySide = ["R", "D", "MS"].includes(orderDetails.label_code);
  const actionType = orderResponse?.id ? "update" : "create";
  const disabledCodes = orderResponse?.id ? getDisabledCodes() : [];
  const status = orderResponse?.status || "";
  const order_label_code =
    _.get(orderResponse, "customer_order_details.order_label", "") || "";
  const backCb = props?.backCb || props?.onCancel;
  // Phase 4.3 Mode A: has the user entered real leg data worth guarding? A
  // chosen location or typed company — NOT los_code, which the SL prefills.
  const hasEnteredLegData = () =>
    (locations || []).some((loc) => loc && (loc.location_id || loc.company_name));

  // Clear the SL-derived leg structure + selection (right-rail fields untouched).
  const resetModeALegs = () => {
    setServiceLevelLegLos(null);
    setOrderDetails((prev) => ({ ...prev, service_level_id: undefined }));
    setLocations([]);
  };

  // Phase 4.3 Mode A: derive order type + effective leg tariffs from the chosen
  // service level and drive the legs. Inline mirror of ServiceLevelOrderModal's
  // handleServiceLevelSelect (state instead of a route-state handoff).
  const applyServiceLevel = (serviceLevelId) => {
    const sl = applicableServiceLevels.find((s) => s.service_level_id === serviceLevelId);
    const labelCode = labelCodeForServiceLevel(serviceLevelId, serviceLevelIndex);
    // Order type: catalog-first (base_order_type rides the SL index) so DB-only
    // move types resolve; enhancedOrderTypes lookup only as a legacy fallback.
    const orderType = serviceLevelIndex[serviceLevelId]?.base_order_type ||
      (labelCode ? getOrderTypeFromLabelCode(labelCode) : "");
    if (!sl || !labelCode || !orderType) {
      // Never invent an order type — fail loudly if the SL's move-type mapping
      // is missing/unrecognized (same guard as the modal).
      renderNotification(
        "Could not determine an order type for the selected service level. Its move type mapping is missing or unrecognized.",
        "error"
      );
      return;
    }
    const legLos = buildLegLos(sl);
    setServiceLevelLegLos(legLos);
    setOrderDetails((prev) => ({
      ...prev,
      type_of_order: orderType,
      label_code: labelCode,
      extra_code: "",
      service_level_id: serviceLevelId,
    }));
    // Propagate service-level options to the order's options block.
    setBondedOrderChecked(!!sl.bonded_freight);
    setFreightType(sl.freight_type || "AIR");
    setSlIsImported(!!sl.is_imported);
    // Explicit override (not state) so legs re-seed even when label_code is
    // unchanged (switching SLs within the same move type).
    getOrderTypeConfig(labelCode, null, "", legLos);
    // Keyboard cascade step 3: SL chosen -> focus the FIRST leg's address
    // search. The legs render on the state update above, so defer a tick; the
    // input is targeted by its stable name attr (first match = first leg).
    // Cross Dock legs (CrossDockFormV2) name their search `cdf2_search` rather
    // than `lav2_location_search`, so match both — otherwise the cascade misses
    // and focus falls through to the leg's phone field.
    if (isNew) {
      deferFocus(() => document.querySelector('input[name="lav2_location_search"], input[name="cdf2_search"]'), 250);
    }
  };
  // Re-selecting an SL with entered leg data confirms before resetting.
  const handleModeAServiceLevelChange = (serviceLevelId) => {
    if (serviceLevelId === orderDetails.service_level_id) return;
    if (orderDetails.service_level_id && hasEnteredLegData()) {
      Modal.confirm({
        title: "Change service level?",
        content: "Changing the service level resets the leg details. Continue?",
        onOk: () => applyServiceLevel(serviceLevelId),
      });
      return;
    }
    applyServiceLevel(serviceLevelId);
  };

  // Phase 4.3 Mode A account change (from AccountBlockV2): clears the SL + all
  // leg data, then loads the new account's SLs (via the for_account effect).
  const applyAccount = (accountId) => {
    // CREATE: legs are SL-derived scaffolding — reset them so the new account's SL
    // rebuilds them. EDIT: the legs hold saved data (addresses, contacts) loaded
    // from the order — never wipe them, or they disappear and never come back.
    // Switching the account on edit only remaps each leg's tariff (via the leg
    // prefill effect in AddressLocationDetails), it must not destroy the legs.
    if (!orderResponse?.id) {
      resetModeALegs();
      setApplicableServiceLevels([]);
    }
    setFieldsValue({ account_id: accountId || "" });
    updateOrderDetails("account_id", accountId || "");
  };

  const handleModeAAccountChange = (accountId) => {
    if (accountId === orderDetails.account_id) return;
    // The clearing confirm is create-only; on edit applyAccount preserves the legs.
    if (!orderResponse?.id && orderDetails.service_level_id && hasEnteredLegData()) {
      Modal.confirm({
        title: "Change account?",
        content: "Changing the account clears the selected service level and leg details. Continue?",
        onOk: () => applyAccount(accountId),
      });
      return;
    }
    applyAccount(accountId);
  };

  const handleModeAClearAccount = () => handleModeAAccountChange("");
  return (
    <Form className="createOrderScreen" onSubmit={handleValidate}>
      <Spin spinning={isWhLoading || isLoading} tip={isWhLoading ? '' : isLoading ? !orderDetails.suppres_schedule_dates ? 'Validating' : 'Creating' : ''}> 
      <Row style={{ height: "100%", width: "100%"}} type="flex">
        <Col
          // span={20}
          style={{
          
            width: "82%",
            height: "100vh",
            // overflowY: "auto",
            padding: "24px",
          }}
            className="hide-scrollbar"
          >
            <Row
              data-testid="create-order-header"
              type="flex"
              justify="space-between"
              align="top"
              style={{
                height: "48px",
                paddingBottom: "8px",
                marginBottom: "16px",
              }}
            >
              <Col>
                <Row type="flex" gutter={24} align="middle">
                {!orderResponse?.id ? (
                    <>
                      <Col>
                        <ArrowBackIcon
                          onClick={() => backCb ? backCb() : props.history.push("/orders")}
                          style={{ cursor: "pointer" }}
                        />
                      </Col>
                      <Col style={{ cursor: "pointer" }} data-testid="change-order-type">
                        <CreateOrderButton
                          viewType="label"
                          // typeOFOrder={orderDetails.label_code || "D"}
                          typeOFOrder={orderTypeConfig.extraCode || orderTypeConfig.code || "D"}
                          reqFrom="create"
                          handleTypeChange={handleTypeChange}
                          disabledCodes={disabledCodes}
                          // Mode A: show the resolved move-type badge in the heading
                          // once an SL is chosen (before that there's no type to show).
                          serviceLevelSelected={!!orderDetails.service_level_id}
                          showOptions={[
                            "",
                            "NEW",
                            "RECEIVED",
                            "VERIFIED",
                            "ON_HOLD",
                          ].includes(status)}
                          currentOrg={currentOrg}
                        />
                      </Col>
                    </>
                  ) : (
                    <Row type="flex" gutter={16}>
                      <Col>
                        <EditOrderCloseIcon
                          // onClick={() => props.history.push("/orders/")}
                          onClick={() => {
                            if (!callFrom.includes("orders")) { //['preplan', 'dispatch']
                              handleClose()
                            }
                            backCb ? backCb() : props.history.push("/orders")
                           }
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </Col>
                      <Col className="center">
                        {/* DB-resolved configs carry short_code/display_color (see
                            buildOrderTypeConfigIndex); legacy enhancedOrderTypes
                            never do, so the legacy icon path is untouched. */}
                        {orderTypeConfig?.short_code ? (
                          <MoveTypeBadge
                            shortCode={orderTypeConfig.short_code}
                            color={orderTypeConfig.display_color}
                            title={orderTypeConfig.label}
                            size={40}
                          />
                        ) : (
                          getOrderTypeIcon(orderTypeConfig?.extraCode || orderTypeConfig?.code || orderDetails.label_code, {
                          width: 40,
                          height: 40,
                          })
                        )}
                      </Col>
                      <Col>
                        <Row>
                          <Col>
                            <span className="title" style={{}}>
                              Order{" "}
                              {orderResponse?.customer_order_details
                                ?.customer_order_number
                                ? ` #${orderResponse?.customer_order_details?.customer_order_number}`
                                : ""}{" "}
                              <Copyable
                                className="orderNumberCopyIcon"
                                text={orderResponse.customer_order_number}
                              />
                            </span>
                          </Col>
                          <Row style={{display: 'flex', alignItems: 'center',}}>
                            {/* <Col className="sub_title">
                              {getColorForTitleCreateOrderScreen_v2(
                                order_label_code,
                                "#273156"
                              )}
                            </Col> */}
                            <DisableWrapper disabled={disableEditLHOrder}>
                              <Col style={{ cursor: "pointer"}} className="orderTypeDropdownSelect" data-testid="change-order-type">
                                <CreateOrderButton
                                  viewType="label"
                                  typeOFOrder={orderTypeConfig?.extraCode || orderTypeConfig?.code || orderDetails.label_code || "D"}
                                  reqFrom="create"
                                  handleTypeChange={handleTypeChange}
                                  disabledCodes={disabledCodes}
                                  showOnlyArrow={true}
                                  showOptions={[
                                    "",
                                    "NEW",
                                    "RECEIVED",
                                    "VERIFIED",
                                    "ON_HOLD",
                                  ].includes(status)}
                                />
                              </Col>
                            </DisableWrapper>
                          </Row>
                        </Row>
                      </Col>
                    </Row>
                  )}
                </Row>
              </Col>
              <Col className="warehouseSelect">
                <Row
                  type="flex"
                  justify="space-between"
                  gutter={10}
                  align="middle"
                >
                  <Col>
                    {" "}
                  <span className="warehouse-label" style={{marginTop:'8px'}}>{I18n.t("general.warehouse")}</span>
                  </Col>
                  <DisableWrapper disabled={disableEditLHOrder}>
                    <Col>
                      <Row
                        type="flex"
                        align="middle"
                        justify="center"
                        className="warehouse-dropdown-field"
                      >
                        <Col>
                          <img src={WarehouseIcon} alt="" />
                        </Col>
                        <Col>
                          <Select_v2
                            key={warehouseSelectKey}
                            data-testid="warehouse-dropdown"
                            options={warehouses}
                            labelField={"name"}
                            valueField={"id"}
                            value={orderDetails.warehouse_id}
                          onChange={(val) => handleWarehouseChange(val)}
                            //   icon={<MenuOutlined />}
                            style={{ width: "100%" }}
                            placeholder="Choose an option"
                            prefixIcon={<Icon type="down" />}
                            loading={isWhLoading}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </DisableWrapper>
                </Row>
              </Col>
            </Row>


         { errors?.length > 0 && <Row className="marginBottom10 order_errors">
                <Col xs={24}>
              <ErrorComponent errors={[...errors]}/>
                </Col>
              </Row>
         }

            {/* First Nested Row */}
            <Row style={{ marginBottom: "16px" }}>
              {/* <DisableWrapper disabled={disableEditLHOrder}> */}
                <Col span={24} data-testid="order-details-block">
                  <div>
                    <OrderdetailsComponent
                      warehouses={warehouses}
                      accInputRef={accInputRef}
                      accounts={accounts}
                      configData={config}
                      updateOrderDetails={updateOrderDetails}
                      referencesData={referencesData}
                      vehicleTypes={vehicleTypes}
                      getDataRef={detailsRef}
                      getFieldDecorator={getFieldDecorator}
                      updatedAccountId={orderDetails.account_id}
                      setFieldsValue={setFieldsValue}
                      order_label_code={orderDetails.label_code || orderDetails.order_label}
                      whStorage={orderDetails.wh_storage}
                      creditsExceededAccnts={creditsExceededAccnts}
                      multiStop = {orderDetails.label_code !== "MS"}
                      actionType={actionType}
                      details={orderDetails}
                      orgSettings={orgContext?.orgSettings || {}}
                      lockAccount={lockAccount}
                      modeAAccountChange={modeA ? handleModeAAccountChange : undefined}
                      modeAClearAccount={modeA ? handleModeAClearAccount : undefined}
                    />
                  </div>
                </Col>
              {/* </DisableWrapper> */}
            </Row>
            {/* Phase 4.3 Mode A: Service Level block — appears once an account is
                chosen (account UI stays AccountBlockV2 above). Drives the legs. */}
            {modeA && orderDetails.account_id && (
              <ServiceLevelHeader
                serviceLevels={applicableServiceLevels}
                serviceLevelIndex={serviceLevelIndex}
                selectedServiceLevelId={orderDetails.service_level_id}
                loadingServiceLevels={loadingServiceLevels}
                onChangeServiceLevel={handleModeAServiceLevelChange}
              />
            )}
            {/* Phase 4.3 Mode A: hide the legs until a service level is chosen —
                but only on CREATE. On edit (orderResponse.id) the legs come from
                the loaded order and must always render. */}
            {(!modeA || orderDetails.service_level_id || orderResponse?.id) && (
            <Row gutter={16} data-testid="location-block">
            {
              orderTypeConfig?.code === 'MS' ?
              <div className="multi_loc_block">
                <SectionCard
                  title="Stops"
                      extraActionNode={orgContext?.orgSettings?.individual_stop_los_order_level === "true" ? null : multiStopItems()}
                >
                  <Tabs
                    activeKey={activeKey}
                    onChange={(key) => setActiveKey(key)}
                  >
                {
                  locations.map((loc, index) => {
                    if (!locationsRef.current[index]) {
                      locationsRef.current[index] = React.createRef();
                    }
                    if (!loc._uniqueKey) {
                      loc._uniqueKey = `loc_${Date.now()}_${Math.random().toString(36)}`;
                    }

                    const stopKey = loc._uniqueKey;

                    const confirmRemove = () => {
                      const newUpdatedLocations = [...locations];
                      const locationData = locationsRef.current.map(ref => ref.current && ref.current()) || [];
                      newUpdatedLocations.splice(index, 1);
                      locationsRef.current.splice(index, 1);

                      const reindexedLocations = newUpdatedLocations.map((loc, newIndex) => ({
                        ...loc,
                        loc_order_sequence: newIndex
                      }));

                      setLocations(reindexedLocations);

                      const foundPreviousStop = locations.find((loc, i) => i === index - 1);
                      setActiveKey(foundPreviousStop._uniqueKey)
                    };

                    if (
                      (activeKey == 1 && index == 0) ||
                      (activeKey == locations.length && index == locations.length - 1)
                    ) {
                      setActiveKey(stopKey);
                    }

                    // const MsDeleteStop = orderDetails.type_of_order == "MS" && loc.loc_order_sequence > 0 && locations.length > 1 && config.allow_single_stop_multiple_stop == "true";

                      return (
                        <Tabs.TabPane
                          tab={
                            <div data-testid={`stop-${index + 1}`} className="MSbutton-2-large" style={{ display: 'flex', alignItems: 'center' }}>
                              <span>Stop {index + 1}</span>
                              {/* {MsDeleteStop && (
                                <Popconfirm
                                  placement="left"
                                  title="Are you sure you want to remove this stop?"
                                  onConfirm={confirmRemove}
                                  okText="Yes"
                                  cancelText="No"
                                  okType="danger"
                                >
                                  <div style={{ display: 'inline-block' }}>
                                    <Icon
                                      type="close"
                                      style={{
                                        marginLeft: 8,
                                        fontSize: 12,
                                        transition: 'color 0.3s',
                                        cursor: 'pointer',
                                        color: '#00000073' // Default color from Ant Design
                                      }}
                                      onMouseEnter={(e) => e.target.style.color = '#ff4d4f'}
                                      onMouseLeave={(e) => e.target.style.color = '#00000073'}
                                    />
                                  </div>
                                </Popconfirm>
                              )} */}
                            </div>
                          }
                          key={stopKey}
                          forceRender
                        >
                          <MultistopOrder
                            isNew={isNew}
                            locObj={loc}
                            accountAccessorial={accessorialDefs?.accountAccData || []}
                            config={config}
                            haveMultipleLocations={locations?.length > 0}
                            displayComponents={accessorialDefs?.displayComponents || []}
                            getFieldDecorator={getFieldDecorator}
                            orderDetails={orderDetails}
                            accountComponentAccessorial={accessorialDefs?.accountAccData || []} 
                            driversData={dtiversData}
                            selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
                            orderTypeConfig={orderTypeConfig}
                            locations={locations}
                            currentAccount={currentAccount || {}}
                            itemsRef={itemsRef}
                            accountId={orderDetails.account_id}
                            levelOfServices={losOptions}
                            warehouses={warehouseFilter}
                            order={order}
                            getDataRef={locationsRef.current[index]}
                            showAccessorial={true}
                            showSidebySide={showSidebySide}
                            accountConfig={config}
                            getAccountComponentDefs={getAccountComponentDefs}
                            form={form}
                            orgContext={orgContext}
                            handleUpdateWhStorage={handleUpdateWhStorage}
                            setLocation ={setLocations}
                            accessorialRef = {accessorialRef}
                            multistopLocationRef={multistopLocationRef}
                            // losRef={losRef}
                            accessorialDefs={accessorialDefs}
                            handleCreatePicsInfo={(pictures) =>
                              handleLocElementUpdate(index, "documents", pictures)
                            }
                            handleRemovePicsInfo={(ackIds) =>
                              handleRemoveDocuments(index, ackIds)
                            }
                            currentOrder={orderDetails?.label_code}
                            actionType={actionType}
                            screenMode={screenMode}
                            msLos={msLos}
                          />
                        </Tabs.TabPane>
                    )
                  })
                }
                        {orderDetails.type_of_order === "MS" && orderDetails.status !== "COMPLETED" && <Tabs.TabPane
                        tab={
                          <Icon className="custom-add-stop-icon" type="plus-circle" onClick={addStop} />
                          }
                        key="add-stop"
                        disabled
                        />}
                  </Tabs>
                </SectionCard>
                </div>
               :
            <Fragment >
                  {/* {!_.isEmpty(orderTypeConfig) && orderTypeConfig.locations && orderTypeConfig.locations.map((loc, index) => { */}
                  {locations.map((loc, index) => {
                const showSidebySide = ['R', 'D', 'MS'].includes(orderDetails.label_code);
                // Phase 4.1 F1 Mode A: the authoritative per-leg tariff for THIS
                // location, resolved from the service-level picker's leg_los that
                // rode in on route state. Only Mode A (props.location.leg_los
                // present) computes it; Mode B (normal create/edit) passes
                // undefined so AddressLocationDetails' existing LOS behavior is
                // byte-identical. resolveLegLosCode already returns undefined for
                // unmatched/ambiguous/unselectable legs, so passing it straight
                // through is safe.
                const serviceLevelLosCode = serviceLevelLegLos
                  ? resolveLegLosCode(loc, serviceLevelLegLos, losOptions)
                  : undefined;
                // The SL/move-type default is sourced from the org Standard sheet,
                // so its specific record is the Standard LOS for that code — pass its
                // id so the leg prefills the Standard "SMF TRACTOR TRAILER (TT)" over
                // a same-code account "TT". undefined when the code isn't a Standard
                // default (then AddressLocationDetails falls back account-first).

                         // Task 5: combo service-level leg lock. A combo SL rates the whole
                // shipment off ONE leg (its per-leg `combo` flag, carried by
                // buildLegLos == combo_leg_sequence). When the chosen SL is combo
                // (some resolved leg has combo === true) AND this Location's matched
                // leg is NOT that combo leg, lock its tariff input — the Task 4
                // backend already forces every non-combo leg to NONE, so this just
                // makes it visible ("Rated via Combo") in AddressLocationDetails.
                // Non-combo SLs have no combo leg → comboLegLocked is false for every
                // leg → Mode B / non-combo Mode A render byte-identical to before.
                const isComboServiceLevel = Array.isArray(serviceLevelLegLos)
                  && serviceLevelLegLos.some((l) => l.combo);
                const comboLegLocked = isComboServiceLevel
                  ? (() => {
                      const matchedLeg = resolveLegLosEntry(loc, serviceLevelLegLos);
                      // Only lock a leg we could unambiguously match and that is NOT
                      // the combo leg; unmatched/combo legs stay editable.
                      return !!matchedLeg && !matchedLeg.combo;
                    })()
                  : false;
                // Account-first default: the leg auto-selects the ACCOUNT tariff for
                // this code (blank rate_sheet_id → account-scoped backend resolution).
                // Only a manual pick of the Standard option sends its rate_sheet_id, so
                // the Standard id / rate_sheet_id no longer need to be threaded down.
                const serviceLevelLosId = serviceLevelLosCode
                  ? standardLosByCode[serviceLevelLosCode]?.id
                  : undefined;
                // The rate_sheet_id the SL/move-type default resolves to (org Standard
                // sheet). Sent with los_code as the backend resolution key.
                const serviceLevelLosRateSheetId = serviceLevelLosCode
                  ? standardLosByCode[serviceLevelLosCode]?.rate_sheet_id
                  : undefined;
                    return (
                      <Fragment>
                  <Col md={showSidebySide ? 24 : 12} xs={24} key={`${loc.label_code}${index}`}>
                          <div>
                            <AddressLocationDetails
                              serviceLevelLosCode={serviceLevelLosCode}
                              serviceLevelLosId={serviceLevelLosId}
                              serviceLevelLosRateSheetId={serviceLevelLosRateSheetId}
                              disableLosEdit={losEditLocked && !!serviceLevelLosCode}
                              comboLegLocked={comboLegLocked}
                              warehouses={warehouseFilter}
                              orderTypeConfig={orderTypeConfig}
                              selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
                              setDeliveryWarehouseID={setDeliveryWarehouseID}
                              deliveryWarehouseID={deliveryWarehouseID}
                              order={order}
                              locObj={loc}
                              levelOfServices={losOptions}
                              handleLocationUpdate={(loc) => handleLocUpdate(index, loc)}
                              getDataRef={locationsRef.current[index]}
                              accountComponentAccessorial={accessorialDefs?.accountAccData || []}  
                              showAccessorial={true} //{!(orderDetails.label_code !== "MS" && locations?.length === 1)}
                              config={config}
                              haveMultipleLocations={locations?.length > 0}
                              displayComponents={accessorialDefs?.displayComponents || []}
                              getFieldDecorator={getFieldDecorator}
                              showSidebySide={showSidebySide}
                              accountConfig={config}
                              getAccountComponentDefs={getAccountComponentDefs}
                              dtiversData={dtiversData}
                              form={form}
                              orgContext={orgContext}
                              currentAccount={currentAccount || {}}
                              handleUpdateWhStorage={handleUpdateWhStorage}
                              updateLocData={updateLocData}
                              targetWarehouse={targetWarehouse}
                              setTargetWarehouse={setTargetWarehouse}
                              actionType={actionType}
                              updatedAccountId={orderDetails.account_id}
                              orderResponse={orderResponse}
                              currentPreplan={currentPreplan}
                              setOutofPreplan={setOutofPreplan}
                              setIsModified={setIsModified}
                              currentRoute={currentRoute}
                              screenMode={screenMode}
                              copyOtherLocation={copyOtherLocation}
                              samaAsOther={samaAsOther}
                              setSamaAsOther={setSamaAsOther}
                              keys={`${refUpdated}${index}`}
                              currentWhCode={currentWhCode}
                              setCurrentWhCode={setCurrentWhCode}
                              setOriginCode={setOriginCode}
                              setDestinationCode={setDestinationCode}
                              setCurrentLocType={setCurrentLocType}
                              disableAddressFields={disableAddressFields}
                              disableEditLHOrder={
                                isLinehaulOrder &&
                                isLinehaulLegEditLocked(
                                  orderDetails.label_code || orderDetails.order_label,
                                  loc.status
                                )
                              }
                              updateOrderDetails={updateOrderDetails}
                              zipcodePLHDcheck={zipcodePLHDcheck}
                              pickupWarehouseId={orderDetails.warehouse_id}
                              orgRules={orgRules}
                              accInputRef={accInputRef}
                            />
                          </div>
                        </Col>
                        {/* {
                    orderDetails.label_code !== "MS" && locations?.length === 1 && <Col span={12}>
                  <div>
                    <CreateOrderAccessorial
                      getDataRef={accessorialRef.current[index]}
                      accountAccessorial={accessorialDefs?.accountAccData || []} 
                      config={config}   
                      haveMultipleLocations={locations?.length > 0}    
                      displayComponents={accessorialDefs?.displayComponents || []}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </div>
                  </Col>
                  } */}
                      </Fragment>
                    );
                  })}
                </Fragment>
}
            </Row>
            )}
            {["LH", "NLH", "PLH", "LHD", "PLHD"]?.includes(orderTypeConfig?.code) &&
              <Row style={{ marginTop: 16 }} data-testid="linehaul-create-form-block">
                <Col span={24}>
                  <LineHaulCreateForm
                    disabled={screenMode === "create" && !orderDetails.warehouse_id}
                    locations={
                      locationsRef.current
                        ?.map((ref) => ref.current && ref.current())
                        .filter(Boolean) || []
                    }
                    pickupDate={pickupAppointmentDate}
                    pickupWarehouseId={linehaulOriginWarehouseId}
                    orderWarehouseId={orderDetails.warehouse_id}
                    deliveryWarehouseId={deliveryWarehouseID || targetWarehouse}
                    orderTypeCode={orderTypeConfig?.code}
                    initialPathId={orderResponse?.linehaul_tracking_info?.path_id}
                    onSelectPath={(pathId) => setLinehaulPathId(pathId)}
                    onChangeTracking={(data) => setLinehaulTrackingData(data)}
                    onChangeSpecial={setLinehaulIsSpecial}
                    orderResponse={orderResponse}
                    losOptions={linehaulLosOptions}
                    serviceLevelLegLos={serviceLevelLegLos}
                    accountId={orderDetails.account_id}
                    serviceLevelFlowEnabled={modeA}
                    accountBillingConfig={accountBillingConfig}
                    orgBillingRules={orgRules?.org_billing_rules || {}}
                  />
                </Col>
              </Row>
            }
            {orderDetails.label_code !== "MS" && (<Row gutter={16} className="marginTop8" data-testid="documents-block">
              {locations.map((loc, index) => {
                  const showSidebySide = ['R', 'D', 'MS'].includes(orderDetails.label_code);
                  const docs = loc?.documents?.filter((doc) => doc?.picture_url !== null);
                return (
                  <Fragment>
                    <Col data-testid={`documents-${loc.type_of_loc}`} md={showSidebySide ? 24 : 12} xs={24} key={`pic${loc.label_code}${index}`}>
                    
                      <Documents
                        getFieldDecorator={getFieldDecorator}
                        currentOrg={currentOrg}
                        accountId={orderDetails.account_id}
                        currentOrder={orderResponse}
                        documents={docs || []}
                        locObj={loc}
                        config={config}
                        handleCreatePicsInfo={(pictures) => handleLocElementUpdate(index, "documents", pictures)}
                        handleRemovePicsInfo={(ackIds) => handleRemoveDocuments(index, ackIds)}
                        actionType={screenMode}
                        orderTypeConfig={orderTypeConfig}
                      />
                      {/* <BulkAttachmentUpload /> */}
                    </Col>
                  </Fragment>
                );
              })}
            </Row>)}
            <Row style={{marginTop: 16}}>
              {((bondedOrderChecked && clearanceRequired) || String(orderResponse?.customer_order_details?.is_imported) === "true" || slIsImported) && (
              <Col xs={24}>
              <CustomsInformation
                getFieldDecorator={getFieldDecorator}
                orderDetails={orderDetails}
                currentOrder={orderResponse}
                currentOrg={orgContext?.currentOrg}
                onDataChange={(data) => {
                  if (data.customsClearedDate) {
                    setFieldsValue({ customs_cleared_date: moment(data.customsClearedDate) });
                  }
                }}
                onCustomsDataChange={setCustomsData}
              />
              </Col>
              )}
            </Row>
            {orgContext?.orgSettings?.require_consignee_details === "true" &&
              <Row style={{ marginTop: 16 }}>
                <Col xs={24} data-testid="consignee-details-block">
                  <ConsigneeDetails
                    viewType={screenMode}
                    form={form}
                    getDataRef={consigneeDetailsRef}
                    getFieldDecorator={getFieldDecorator}
                    getFieldsValue={getFieldValue}
                    currentOrder={orderResponse}
                    consigneeDetails={orderResponse?.consignee_details}
                    selectedWarehouse={selectedWarehouse}
                  />
                </Col>
              </Row>
            }
              <Row className="marginTop15" gutter={16}>
                <Col xs={24} data-testid="items-measure-block">
                  {orgContext?.orgSettings?.items_measure_units_screen === 'true' ? (
                    <ItemsMeasureUnits getDataRef={itemsRef}
                      currentOrg={currentOrg}
                      accountId={orderDetails.account_id}
                      form={form}
                      currentOrder={orderResponse}
                      actionType={actionType}
                      typeOfOrder={orderDetails?.label_code}
                      locationsData={locations}
                      orgSettings={orgContext?.orgSettings || {}}
                      screenFrom={screenFrom}
                      config={config}
                      onBlockedChange={handleItemsMeasureBlockedChange}
                      requiredDimsConfig={orgRules?.org_billing_rules?.required_dims === "true"}
                      saveRef={itemsSaveRef}
                    />
                  ) : (
                    <ItemsMeasure getDataRef={itemsRef}
                      currentOrg={currentOrg}
                      accountId={orderDetails.account_id}
                      form={form}
                      currentOrder={orderResponse}
                      actionType={actionType}
                      typeOfOrder={orderDetails?.label_code}
                      locationsData={locations}
                      orgSettings={orgContext?.orgSettings || {}}
                      screenFrom={screenFrom}
                      config={config}
                    />
                  )}
                </Col>
              </Row>
            
          { orderDetails.type_of_order === 'LH' && orderDetails.order_label === 'LH' && <Row className="marginTop20" gutter={16}>
                <Col xs={24} data-testid="sub-orders-block">
                <SubOrders 
                    getDataRef={subOrdersRef} 
                    getFieldDecorator={getFieldDecorator}
                    selectedWarehouse={selectedWarehouse}
                    accounts={accounts}
                    targetWarehouse={targetWarehouse}
                    warehouseFilter={warehouseFilter}
                    subOrders={orderResponse?.sub_orders || []}
                    showSave={false}
                    screenMode={screenMode}
                    waitTime={waitTime}
                  />
                </Col>
          </Row>}
            <Row className="marginTop20" gutter={16}>
              <Col xs={orderDetails.label_code !== "MS" ? 12 : 24} data-testid="warehouse-accessorials-block">
                {/* <ShipperEmails 
              getDataRef={managerMailsRef} 
              getFieldDecorator={getFieldDecorator} 
              accountId={orderDetails.account_id}
              existingData={orderResponse?.account_manager_emails || []}
              
              /> */}
                <WarehouseAccessorials
                  currentOrg={currentOrg}
                  accountId={orderDetails.account_id || ""}
                  currentOrder={orderResponse}
                  actionType={"create"}
                  savedRecords={orderResponse?.customer_order_details?.warehouse_accessorials || []}
                  showActions={showActionsFunc(isShipper, orderResponse?.customer_order_details)}
                  isShipper={isShipper}
                  setOutofPreplan={setOutofPreplan}
                  setIsModified={setIsModified}
                  onAccessorialsSave={handleAccessorialsUpdate}
                />
              </Col>
              {orderDetails.label_code !== "MS" && (
                <Col xs={12} data-testid="label-info-block">
                  <OrderLabelInfo
                    getDataRef={labelInfoRef}
                    getFieldDecorator={getFieldDecorator}
                    labelInfo={orderResponse?.label_info || {}}
                    actionType={actionType}
                    currentOrder={orderResponse}
                    orderTypeConfig={orderTypeConfig}
                    selectedWarehouse={selectedWarehouse}
                    currentWhCode={currentWhCode}
                    originCode={originCode}
                    destinationCode={destinationCode}
                    isNew={isNew}
                    currentLocType={currentLocType}
                  />
                </Col>
              )}
            </Row>
          <Row className="marginTop20" gutter={16}>
          <Col data-testid="shipper-emails-block">
          <ShipperEmails 
              getDataRef={managerMailsRef} 
              getFieldDecorator={getFieldDecorator} 
              accountId={orderDetails.account_id}
              existingData={orderResponse?.account_manager_emails || []}
              
              /></Col>
          </Row>
          </Col>
          <Col
            data-testid="order-side-bar"
            style={{ width: "18%", padding: "24px 16px", background: "white" }}
          >
            {/* <Button type="primary" onClick={handleValidate}>Create</Button> */}
            {/* Content for the 5-span column */}
            {renderSidebar()}
          </Col>
          <Col></Col>
        </Row>
      </Spin>
    </Form>
  );
};

export default withRouter(Form.create()(CreateOrderScreen));

CreateOrderScreen.propTypes = {
  currentPreplan: PropTypes.shape(),
  currentRoute: PropTypes.shape(),
  handleClose: PropTypes.func,
  callFrom: PropTypes.string,
  setIsModified:  PropTypes.func,
  setOutofPreplan: PropTypes.func,
  screenFrom: PropTypes.string
};
CreateOrderScreen.defaultProps = {
  currentPreplan: {},
  currentRoute: {},
  handleClose: () => { },
  setIsModified: () => { },
  setOutofPreplan: () => { },
  callFrom: "orders",
  screenFrom: "orders"
};
